/**
 * Cart drawer + cart line updates (Eyejack).
 * Depends on window.EyejackCart (set in cart-drawer snippet).
 */
(function () {
  'use strict';

  var config = window.EyejackCart || {};
  var routes = config.routes || {};
  var currencyCodeEnabled = !!config.currencyCodeEnabled;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-open-lens-from-cart]');
    if (!btn) return;
    e.preventDefault();
    if (typeof window.__ejLensSelectorInit === 'function') {
      window.__ejLensSelectorInit();
    }
    if (typeof window.openLensAdvisorDrawer === 'function') {
      window.openLensAdvisorDrawer(btn);
    }
  });

  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this;
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  /** Last Luna unified fill scale (0–1); survives full #CartDrawer innerHTML swaps for FLIP animation. */
  var lastTierUnifiedFillScale = null;

  /** Coalesce tier bar updates so width/transform transitions are not restarted every tick (optimistic cart). */
  var tierOfferUpdateRaf = null;
  function scheduleTierOfferCardUpdate(container) {
    if (tierOfferUpdateRaf) cancelAnimationFrame(tierOfferUpdateRaf);
    tierOfferUpdateRaf = requestAnimationFrame(function () {
      tierOfferUpdateRaf = null;
      updateTierOfferCardUI(container);
    });
  }

  /** Single track fill 0–100; same math as three segments: (s1+s2+s3)/3. */
  function tierUnifiedFillPercent(s1, s2, s3) {
    return (s1 + s2 + s3) / 3;
  }

  function parseScaleXFromTransform(transformStr) {
    if (!transformStr || transformStr === 'none') return null;
    var s = String(transformStr);
    var m = s.match(/scaleX\(\s*([0-9.eE+-]+)\s*\)/);
    if (m) return parseFloat(m[1], 10);
    var mat = s.match(/matrix\(\s*([0-9.eE+-]+)\s*,/);
    if (mat) return parseFloat(mat[1], 10);
    return null;
  }

  function getTierUnifiedFillScale(el) {
    if (!el) return null;
    var attr = el.getAttribute('data-luna-fill-scale');
    if (attr !== null && attr !== '') {
      var v = parseFloat(attr, 10);
      if (!isNaN(v)) return Math.max(0, Math.min(1, v));
    }
    var t = el.style && el.style.transform;
    var p = parseScaleXFromTransform(t);
    if (p != null && !isNaN(p)) return Math.max(0, Math.min(1, p));
    if (typeof window.getComputedStyle === 'function') {
      var cs = window.getComputedStyle(el).transform;
      p = parseScaleXFromTransform(cs);
      if (p != null && !isNaN(p)) return Math.max(0, Math.min(1, p));
    }
    return null;
  }

  /**
   * After full section HTML swap, the new fill is painted at the target scale — no CSS transition.
   * Re-apply previous scale, then animate to the server-rendered target so motion matches qty changes.
   */
  function animateTierUnifiedFillAfterSectionSwap(prevScale) {
    if (prevScale == null || isNaN(prevScale)) return;
    var el = document.querySelector('#CartDrawer [data-tier-unified-fill]');
    if (!el) return;
    var targetScale = parseScaleXFromTransform(el.style && el.style.transform);
    if (targetScale == null || isNaN(targetScale)) {
      var styleAttr = el.getAttribute('style') || '';
      var m = styleAttr.match(/scaleX\(\s*([0-9.eE+-]+)\s*\)/);
      if (m) targetScale = parseFloat(m[1], 10);
    }
    if (targetScale == null || isNaN(targetScale)) return;
    prevScale = Math.max(0, Math.min(1, prevScale));
    targetScale = Math.max(0, Math.min(1, targetScale));
    if (Math.abs(prevScale - targetScale) < 0.0001) return;

    var flipDone = false;
    function finishFlip() {
      if (flipDone) return;
      flipDone = true;
      el.removeAttribute('data-ej-flip-animating');
      var itemsEl = document.querySelector('cart-drawer-items');
      if (itemsEl) runOfferCard(itemsEl);
    }

    el.setAttribute('data-ej-flip-animating', '1');
    el.style.transition = 'none';
    el.style.transform = 'scaleX(' + prevScale + ') translateZ(0)';
    el.style.transformOrigin = 'left center';
    el.setAttribute('data-luna-fill-scale', String(Math.round(prevScale * 10000) / 10000));
    void el.offsetHeight;

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (!el.isConnected) {
          finishFlip();
          return;
        }
        el.style.removeProperty('transition');
        el.style.transform = 'scaleX(' + targetScale + ') translateZ(0)';
        el.setAttribute('data-luna-fill-scale', String(Math.round(targetScale * 10000) / 10000));
        lastTierUnifiedFillScale = Math.round(targetScale * 10000) / 10000;
        el.addEventListener(
          'transitionend',
          function onEnd(e) {
            if (e.propertyName !== 'transform') return;
            el.removeEventListener('transitionend', onEnd);
            finishFlip();
          },
          false
        );
        setTimeout(finishFlip, 700);
      });
    });
  }

  function setLunaSegmentFillScale(el, pct) {
    if (!el) return;
    if (el.getAttribute && el.getAttribute('data-ej-flip-animating') === '1') return;
    var s = Math.max(0, Math.min(1, pct / 100));
    /* Round so we don't restart the CSS transition when the value is effectively unchanged. */
    var rounded = Math.round(s * 10000) / 10000;
    var prev = el.getAttribute('data-luna-fill-scale');
    if (prev !== null && Math.abs(parseFloat(prev, 10) - rounded) < 0.00005) return;
    el.setAttribute('data-luna-fill-scale', String(rounded));
    el.style.transform = 'scaleX(' + rounded + ') translateZ(0)';
    el.style.transformOrigin = 'left center';
    lastTierUnifiedFillScale = rounded;
  }

  function trapFocus(container, elementToFocus) {
    if (!container) return;
    var focusable = container.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    function onKey(e) {
      if (e.code !== 'Tab') return;
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last && last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first && first.focus();
        }
      }
    }
    container._trapFocusKeydown = onKey;
    container.addEventListener('keydown', onKey);
    (elementToFocus || first || container).focus && (elementToFocus || first || container).focus();
  }

  function removeTrapFocus(container) {
    if (!container || !container._trapFocusKeydown) return;
    container.removeEventListener('keydown', container._trapFocusKeydown);
    delete container._trapFocusKeydown;
  }

  function onKeyUpEscape(e) {
    if (e.code === 'Escape') {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && drawer.close) drawer.close();
    }
  }

  function fetchConfig(type, init) {
    return Object.assign(
      {
        method: type,
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      },
      init || {}
    );
  }

  function fetchWithRetry(url, config, maxRetries) {
    var retries = maxRetries || 3;
    function attempt(n) {
      return fetch(url, config).then(function (r) {
        if (r.status === 429 && n < retries) {
          var wait = Math.min(1000 * Math.pow(2, n), 4000);
          return new Promise(function (resolve) {
            setTimeout(function () { resolve(attempt(n + 1)); }, wait);
          });
        }
        return r;
      });
    }
    return attempt(0);
  }

  function getSectionInnerHTML(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector || '.shopify-section');
    return el ? el.innerHTML : '';
  }

  /**
   * Smart cart list reconciliation: merges server-rendered <li> items into the
   * live DOM without tearing down unchanged nodes.  This prevents image flicker
   * and layout jank that innerHTML replacement causes.
   *
   * @param {Element} currentList  Live .sidebar-cart-list element
   * @param {Element} serverList   Parsed server .sidebar-cart-list element
   * @returns {boolean} true if reconciliation succeeded
   */
  function reconcileCartList(currentList, serverList) {
    if (!currentList || !serverList) return false;

    function lineKeyOf(li) {
      return li.getAttribute('data-line-item-key') || null;
    }
    function variantIdOf(li) {
      var inp = li.querySelector('input[data-quantity-variant-id]');
      return inp ? inp.getAttribute('data-quantity-variant-id') : null;
    }

    var serverLis = [];
    for (var sc = serverList.firstElementChild; sc; sc = sc.nextElementSibling) {
      if (sc.tagName === 'LI') serverLis.push(sc);
    }
    if (serverLis.length === 0) return false;

    var currentLis = [];
    for (var cc = currentList.firstElementChild; cc; cc = cc.nextElementSibling) {
      if (cc.tagName === 'LI') currentLis.push(cc);
    }

    /* Build lookup maps for current DOM items.
       Optimistic items (data-optimistic="1") are included in the variant-ID
       map so they can be matched and upgraded in-place by patchCartItemInPlace,
       preventing a visible insert-then-remove flicker. They are excluded
       from the line-item-key map since they don't have real keys. */
    var currentByKey = {};
    var currentByVariantArr = {};
    currentLis.forEach(function (li) {
      var isOptimistic = li.getAttribute('data-optimistic') === '1';
      if (!isOptimistic) {
        var key = lineKeyOf(li);
        if (key) {
          if (!currentByKey[key]) currentByKey[key] = [];
          currentByKey[key].push(li);
        }
      }
      var vid = variantIdOf(li);
      if (vid) {
        if (!currentByVariantArr[vid]) currentByVariantArr[vid] = [];
        currentByVariantArr[vid].push(li);
      }
    });

    /* Track which DOM nodes are "kept" (matched to a server item).
       Tag each kept node with a unique marker attribute. */
    var keptMark = '_ejKept' + Date.now();

    /* Walk server items in order and reconcile */
    var prevNode = null;

    for (var i = 0; i < serverLis.length; i++) {
      var sLi = serverLis[i];
      var sKey = lineKeyOf(sLi);
      var sVid = variantIdOf(sLi);

      var existing = null;

      /* Match by line-item key first (precise) */
      if (sKey && currentByKey[sKey]) {
        for (var ki = 0; ki < currentByKey[sKey].length; ki++) {
          if (!currentByKey[sKey][ki].hasAttribute(keptMark)) {
            existing = currentByKey[sKey][ki];
            break;
          }
        }
      }
      /* Fallback: match by variant ID (for items without keys) */
      if (!existing && sVid && currentByVariantArr[sVid]) {
        for (var vi = 0; vi < currentByVariantArr[sVid].length; vi++) {
          if (!currentByVariantArr[sVid][vi].hasAttribute(keptMark)) {
            existing = currentByVariantArr[sVid][vi];
            break;
          }
        }
      }

      if (existing) {
        existing.setAttribute(keptMark, '1');
        patchCartItemInPlace(existing, sLi);
        if (prevNode) {
          if (existing.previousElementSibling !== prevNode) {
            prevNode.after(existing);
          }
        } else if (existing !== currentList.firstElementChild) {
          currentList.prepend(existing);
        }
        prevNode = existing;
      } else {
        if (prevNode) {
          prevNode.after(sLi);
        } else {
          currentList.prepend(sLi);
        }
        prevNode = sLi;
      }
    }

    /* Remove ALL <li> elements that weren't matched to a server item.
       This catches orphaned items from optimistic updates, stale renders,
       duplicate keys from cloning, or structure changes from BOGO. */
    for (var ri = currentLis.length - 1; ri >= 0; ri--) {
      if (!currentLis[ri].hasAttribute(keptMark) && currentLis[ri].parentNode) {
        currentLis[ri].remove();
      } else {
        currentLis[ri].removeAttribute(keptMark);
      }
    }

    /* Copy non-li children (status/live-region elements) from server */
    var serverStatus = serverList.querySelectorAll('p[role="status"]');
    serverStatus.forEach(function (sp) {
      var id = sp.id;
      if (!id) return;
      var live = currentList.querySelector('#' + id);
      if (live) {
        live.textContent = sp.textContent;
      }
    });

    return true;
  }

  /**
   * Update a single cart <li> in-place from a server-rendered <li>,
   * preserving image elements to prevent decode flicker.
   */
  function patchCartItemInPlace(currentLi, serverLi) {
    /* Helper: set attribute only if value actually changed */
    function setIfChanged(el, name, val) {
      if (el.getAttribute(name) !== val) el.setAttribute(name, val);
    }

    /* 1. Sync all data-* attributes on the <li> — skip if identical */
    var sAttrs = serverLi.attributes;
    for (var i = 0; i < sAttrs.length; i++) {
      setIfChanged(currentLi, sAttrs[i].name, sAttrs[i].value);
    }
    var cAttrs = Array.prototype.slice.call(currentLi.attributes);
    for (var j = 0; j < cAttrs.length; j++) {
      if (cAttrs[j].name.indexOf('data-') === 0 && !serverLi.hasAttribute(cAttrs[j].name)) {
        currentLi.removeAttribute(cAttrs[j].name);
      }
    }

    /* 2. Quantity input: sync value + attributes only if changed */
    var cInp = currentLi.querySelector('.quantity__input');
    var sInp = serverLi.querySelector('.quantity__input');
    if (cInp && sInp) {
      if (cInp.value !== sInp.value) cInp.value = sInp.value;
      var inpAttrs = sInp.attributes;
      for (var k = 0; k < inpAttrs.length; k++) {
        setIfChanged(cInp, inpAttrs[k].name, inpAttrs[k].value);
      }
    }

    /* 3. Price block: only replace innerHTML if content actually differs */
    var cPrice = currentLi.querySelector('.dz-price');
    var sPrice = serverLi.querySelector('.dz-price');
    if (cPrice && sPrice) {
      if (cPrice.innerHTML !== sPrice.innerHTML) cPrice.innerHTML = sPrice.innerHTML;
      var sPriceAttrs = sPrice.attributes;
      for (var pa = 0; pa < sPriceAttrs.length; pa++) {
        setIfChanged(cPrice, sPriceAttrs[pa].name, sPriceAttrs[pa].value);
      }
    }

    /* 4. Variant/option labels: only replace if changed */
    var cVars = currentLi.querySelector('.dz-product-variants');
    var sVars = serverLi.querySelector('.dz-product-variants');
    if (cVars && sVars) {
      if (cVars.innerHTML !== sVars.innerHTML) cVars.innerHTML = sVars.innerHTML;
    } else if (!cVars && sVars) {
      var contentDiv = currentLi.querySelector('.dz-content');
      var titleEl = contentDiv && contentDiv.querySelector('.title');
      if (titleEl) titleEl.after(sVars);
    }

    /* 5. Quantity wrapper: update remove button index + select-lens */
    var cRemove = currentLi.querySelector('cart-remove-button');
    var sRemove = serverLi.querySelector('cart-remove-button');
    if (cRemove && sRemove) {
      setIfChanged(cRemove, 'data-index', sRemove.getAttribute('data-index') || '');
      if (cRemove.id !== (sRemove.id || '')) cRemove.id = sRemove.id || '';
    }
    var cLensBtn = currentLi.querySelector('[data-open-lens-from-cart]');
    var sLensBtn = serverLi.querySelector('[data-open-lens-from-cart]');
    if (cLensBtn && sLensBtn) {
      setIfChanged(cLensBtn, 'data-variant-id', sLensBtn.getAttribute('data-variant-id') || '');
      setIfChanged(cLensBtn, 'data-product-handle', sLensBtn.getAttribute('data-product-handle') || '');
      setIfChanged(cLensBtn, 'data-variant-sku', sLensBtn.getAttribute('data-variant-sku') || '');
    } else if (!cLensBtn && sLensBtn) {
      var cQW = currentLi.querySelector('.cart-item__quantity-wrapper');
      if (cQW) cQW.insertBefore(sLensBtn.cloneNode(true), cQW.querySelector('cart-remove-button'));
    } else if (cLensBtn && !sLensBtn) {
      cLensBtn.remove();
    }

    /* 6. Image: preserve if src matches, otherwise update src only */
    var cImg = currentLi.querySelector('.cart-item__image');
    var sImg = serverLi.querySelector('.cart-item__image');
    if (cImg && sImg) {
      var cSrc = (cImg.getAttribute('src') || '').split('?')[0];
      var sSrc = (sImg.getAttribute('src') || '').split('?')[0];
      if (cSrc !== sSrc) {
        cImg.setAttribute('src', sImg.getAttribute('src'));
      }
      if (sImg.getAttribute('alt') !== cImg.getAttribute('alt')) {
        cImg.setAttribute('alt', sImg.getAttribute('alt') || '');
      }
    }
  }

  /**
   * Liquid routes are usually "/cart/add", but if the leading slash is ever missing,
   * fetch("cart/add.js") resolves against the current pathname → 404 (e.g. /collections/x/cart/add.js).
   */
  function normalizeStorePath(path) {
    var p = String(path || '').trim();
    if (!p) return '';
    if (/^https?:\/\//i.test(p)) return p;
    if (p.charAt(0) !== '/') return '/' + p;
    return p;
  }

  function getCartAddJsUrl() {
    if (routes.cartAddUrl) {
      var u = normalizeStorePath(String(routes.cartAddUrl).trim());
      if (u.indexOf('.js') !== -1) return u;
      return u.replace(/\/?$/, '') + '.js';
    }
    return normalizeStorePath(root.endsWith('/') ? root + 'cart/add.js' : root + '/cart/add.js');
  }

  function getCartJsUrl() {
    var u = '';
    if (routes.cartUrl) {
      u = normalizeStorePath(String(routes.cartUrl).trim().replace(/\/?$/, ''));
    }
    if (!u) {
      u = normalizeStorePath(root.endsWith('/') ? root + 'cart' : root + '/cart');
    }
    return u.indexOf('.js') !== -1 ? u : u + '.js';
  }

  function getCartChangeJsUrl() {
    if (routes.cartChangeUrl) {
      var u = normalizeStorePath(String(routes.cartChangeUrl).trim());
      if (u.indexOf('.js') !== -1) return u;
      return u.replace(/\/?$/, '') + '.js';
    }
    return normalizeStorePath(root.endsWith('/') ? root + 'cart/change.js' : root + '/cart/change.js');
  }

  function getCartUpdateJsUrl() {
    return normalizeStorePath(root.endsWith('/') ? root + 'cart/update.js' : root + '/cart/update.js');
  }

  /** Line item property value → string (handles plain + some structured shapes). */
  function cartPropertyString(val) {
    if (val == null) return '';
    if (typeof val === 'string') return val.trim();
    if (typeof val === 'object' && val.value != null) return String(val.value).trim();
    return String(val).trim();
  }

  function isLensAdvizorLineItem(item) {
    return String(item && item.vendor ? item.vendor : '')
      .toLowerCase()
      .trim() === 'lensadvizor';
  }

  function variantIdsEqual(a, b) {
    var na = parseInt(String(a), 10);
    var nb = parseInt(String(b), 10);
    return !isNaN(na) && !isNaN(nb) && na === nb;
  }

  function cartSkusEqual(cartSku, refSku) {
    var a = String(cartSku != null ? cartSku : '')
      .trim()
      .toLowerCase();
    var b = String(refSku != null ? refSku : '')
      .trim()
      .toLowerCase();
    return a !== '' && b !== '' && a === b;
  }

  /**
   * 1-based cart line index for the frame tied to a lens line (SKU or VAR-{variant_id} from lens-selector).
   * excludeLine: lens line — never treat the lens row as the frame.
   */
  function findFrameLineByRef(cartItems, frameRef, excludeLine) {
    var ref = cartPropertyString(frameRef);
    if (!ref || !cartItems || !cartItems.length) return null;
    var i;
    if (ref.indexOf('VAR-') === 0) {
      var vid = parseInt(ref.slice(4), 10);
      if (isNaN(vid)) return null;
      for (i = 0; i < cartItems.length; i++) {
        if (i + 1 === excludeLine) continue;
        if (variantIdsEqual(cartItems[i].variant_id, vid)) return i + 1;
      }
      return null;
    }
    for (i = 0; i < cartItems.length; i++) {
      if (i + 1 === excludeLine) continue;
      var sku = cartItems[i].sku != null ? String(cartItems[i].sku).trim() : '';
      if (cartSkusEqual(sku, ref)) return i + 1;
    }
    return null;
  }

  /** True if lens line property value points at this frame line (SKU or VAR-{variant_id}). */
  function frameRefMatchesLineItem(frameItem, frameRef) {
    var ref = cartPropertyString(frameRef);
    if (!ref || !frameItem) return false;
    if (ref.indexOf('VAR-') === 0) {
      var vid = parseInt(ref.slice(4), 10);
      if (isNaN(vid)) return false;
      return variantIdsEqual(frameItem.variant_id, vid);
    }
    var sku = frameItem.sku != null ? String(frameItem.sku).trim() : '';
    return cartSkusEqual(sku, ref);
  }

  /**
   * 1-based line indices of LensAdvizor items whose Associated Frame / Frame SKU matches frameLineItem.
   * excludeLine: the frame row being removed — never return that line as a "lens".
   */
  function findLensLinesForFrame(cartItems, excludeLine, frameLineItem) {
    if (!cartItems || !cartItems.length || !frameLineItem) return [];
    var out = [];
    var i;
    for (i = 0; i < cartItems.length; i++) {
      var lineNo = i + 1;
      if (lineNo === excludeLine) continue;
      var item = cartItems[i];
      if (!isLensAdvizorLineItem(item)) continue;
      var props = item.properties || {};
      var ref =
        cartPropertyString(props['Associated Frame']) || cartPropertyString(props['Frame SKU']);
      if (frameRefMatchesLineItem(frameLineItem, ref)) {
        out.push(lineNo);
      }
    }
    return out;
  }

  /** DOM-only: match lens line property ref to frame line (variant VAR-* or SKU). */
  function frameRefMatchesLineItemFromDom(frameVid, frameSku, ref) {
    ref = cartPropertyString(ref);
    if (!ref) return false;
    if (ref.indexOf('VAR-') === 0) {
      var vid = parseInt(ref.slice(4), 10);
      return !isNaN(vid) && !isNaN(frameVid) && vid === frameVid;
    }
    return cartSkusEqual(frameSku, ref);
  }

  function domLineForFrameRef(drawer, ref, excludeLine) {
    ref = cartPropertyString(ref);
    if (!ref || !drawer) return null;
    var list = drawer.querySelector('.sidebar-cart-list');
    if (!list) return null;
    var lis = list.querySelectorAll('li');
    var i;
    if (ref.indexOf('VAR-') === 0) {
      var vid = parseInt(ref.slice(4), 10);
      if (isNaN(vid)) return null;
      for (i = 0; i < lis.length; i++) {
        var lineNo = i + 1;
        if (lineNo === excludeLine) continue;
        var inp = lis[i].querySelector('input[name="updates[]"]');
        var vidAttr = inp && inp.getAttribute('data-quantity-variant-id');
        if (vidAttr != null && parseInt(vidAttr, 10) === vid) return lineNo;
      }
      return null;
    }
    for (i = 0; i < lis.length; i++) {
      var lineNo2 = i + 1;
      if (lineNo2 === excludeLine) continue;
      var sku = lis[i].getAttribute('data-item-sku') || '';
      if (cartSkusEqual(sku, ref)) return lineNo2;
    }
    return null;
  }

  function findLensLinesInDom(drawer, frameLineNum, frameLi) {
    if (!drawer || !frameLi) return [];
    var inp = frameLi.querySelector('input[name="updates[]"]');
    var frameVid = inp ? parseInt(inp.getAttribute('data-quantity-variant-id'), 10) : NaN;
    var frameSku = frameLi.getAttribute('data-item-sku') || '';
    var out = [];
    var list = drawer.querySelector('.sidebar-cart-list');
    if (!list) return [];
    var lis = list.querySelectorAll('li');
    for (var i = 0; i < lis.length; i++) {
      var lineNo = i + 1;
      if (lineNo === frameLineNum) continue;
      var li = lis[i];
      if (li.getAttribute('data-ej-lens-advizor') !== 'true') continue;
      var ref = li.getAttribute('data-ej-frame-ref') || '';
      if (!ref) continue;
      if (frameRefMatchesLineItemFromDom(frameVid, frameSku, ref)) out.push(lineNo);
    }
    return out;
  }

  function getVariantIdForLine(drawerEl, lineNum) {
    if (!drawerEl) return null;
    var inp = drawerEl.querySelector('input[name="updates[]"][data-index="' + String(lineNum) + '"]');
    if (inp) {
      var vid = inp.getAttribute('data-quantity-variant-id');
      if (vid) return String(vid);
    }
    var rmBtn = drawerEl.querySelector('cart-remove-button[data-index="' + lineNum + '"] button[data-variant-id]');
    if (rmBtn) return rmBtn.getAttribute('data-variant-id') || null;
    return null;
  }

  /**
   * Before optimistic DOM removal: decide single vs paired lens/frame remove without /cart.js.
   * mode 'fetch' = fall back to cart JSON (missing data-* or ambiguous).
   */
  function resolveRemovePairFromDomBeforeOptimistic(lineNum) {
    var cd = document.getElementById('CartDrawer');
    if (!cd) return { mode: 'fetch' };
    var inp = cd.querySelector('input[name="updates[]"][data-index="' + String(lineNum) + '"]');
    var li = inp && inp.closest('li');
    if (!li) return { mode: 'fetch' };

    var list = cd.querySelector('.sidebar-cart-list');
    if (!list) return { mode: 'fetch' };
    var allLis = list.querySelectorAll('li');
    if (allLis.length <= 1) {
      return { mode: 'simple' };
    }

    if (li.getAttribute('data-ej-lens-advizor') === 'true') {
      var ref = li.getAttribute('data-ej-frame-ref') || '';
      if (!ref) {
        return { mode: 'simple' };
      }
      var frameLine = domLineForFrameRef(cd, ref, lineNum);
      if (frameLine && frameLine !== lineNum) {
        return { mode: 'multi', lines: [lineNum, frameLine] };
      }
      return { mode: 'simple' };
    }

    var lensLines = findLensLinesInDom(cd, lineNum, li);
    if (lensLines.length) {
      return { mode: 'multi', lines: [lineNum].concat(lensLines) };
    }
    return { mode: 'simple' };
  }

  function formToCartLineItem(form) {
    var fd = new FormData(form);
    var id = fd.get('id');
    if (id == null || id === '') return null;
    var vid = parseInt(String(id), 10);
    if (isNaN(vid)) return null;
    var qty = parseInt(String(fd.get('quantity') != null ? fd.get('quantity') : '1'), 10);
    if (isNaN(qty) || qty < 1) qty = 1;
    var item = { id: vid, quantity: qty };
    var properties = {};
    fd.forEach(function (value, key) {
      if (key.indexOf('properties[') !== 0) return;
      var m = key.match(/^properties\[([^\]]+)\]/);
      if (m) properties[m[1]] = String(value);
    });
    if (Object.keys(properties).length) item.properties = properties;
    var sp = fd.get('selling_plan');
    if (sp != null && String(sp) !== '') {
      var sid = parseInt(String(sp), 10);
      if (!isNaN(sid)) item.selling_plan = sid;
    }
    return item;
  }

  function cartAddErrorMessage(state) {
    if (!state) return 'Could not add to cart.';
    if (state.description) {
      if (typeof state.description === 'string') return state.description;
      if (state.description.message) return String(state.description.message);
    }
    if (state.message) return String(state.message);
    if (state.errors) {
      var e = state.errors;
      if (typeof e === 'string') return e;
      var k = Object.keys(e)[0];
      if (k) {
        var v = e[k];
        return Array.isArray(v) ? String(v[0]) : String(v);
      }
    }
    return 'Could not add to cart.';
  }

  function normalizeAddResponse(state) {
    if (!state || typeof state !== 'object') return state;
    if (typeof state.item_count !== 'number') {
      var items = state.items;
      if (items && items.length) {
        state.item_count = items.reduce(function (n, li) {
          return n + (parseInt(li.quantity, 10) || 0);
        }, 0);
      }
    }
    return state;
  }

  function escapeHtml(str) {
    if (!str) return '';
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function fetchCartDrawerSectionMarkup() {
    var q = root.endsWith('/') ? root + '?sections=cart-drawer' : root + '/?sections=cart-drawer';
    q += '&_t=' + Date.now();
    return fetchWithRetry(q, { headers: { Accept: 'application/json' }, cache: 'no-store' }, 2).then(function (r) {
      return r.json();
    });
  }

  function getDomCartLineCount() {
    var list = document.querySelector('#CartDrawer .sidebar-cart-list');
    if (!list) return 0;
    return list.querySelectorAll('li[data-item-quantity]').length;
  }

  function cartDrawerHasNoLineItems(cartRoot) {
    if (!cartRoot) return false;
    var list = cartRoot.querySelector('.sidebar-cart-list');
    return !list || list.querySelectorAll('li[data-item-quantity]').length === 0;
  }

  /**
   * After the last line is removed optimistically, cart JSON may still be in-flight.
   * Show empty state immediately and hide footer / recommended / checkout until section HTML refreshes.
   */
  function syncCartDrawerEmptyUi(drawerEl, opts) {
    var drawer = drawerEl || document.getElementById('CartDrawer');
    if (!drawer) return;
    var force = opts && opts._optimistic;

    if (window._ejAddInFlight && !force) return;
    if (window._ejRemovalsInFlight && !force) return;

    var count = getDomCartLineCount();
    var n = 0;
    drawer.querySelectorAll('input[name="updates[]"]').forEach(function (inp) {
      var v = parseInt(inp.value || '0', 10);
      if (!isNaN(v)) n += v;
    });
    /* Also count optimistic items that don't have name="updates[]" yet */
    var optimistic = drawer.querySelectorAll('li[data-optimistic]').length;
    var isEmpty = count === 0 && n === 0 && optimistic === 0;
    drawer.classList.toggle('cart-drawer--empty', isEmpty);
    var empty = drawer.querySelector('.drawer-empty');
    if (empty) empty.hidden = !isEmpty;

    /* Block late section HTML from reopening empty drawer — start window as soon as cart reads empty. */
    var host = document.querySelector('cart-drawer');
    if (host) {
      if (isEmpty) {
        host._suppressEmptyCartAutoOpenUntil = Date.now() + 5000;
      } else {
        host._suppressEmptyCartAutoOpenUntil = 0;
      }
    }
  }

  /**
   * Patch cart line rows from /cart/change.js JSON (no section HTML). Only valid when
   * cart.items.length matches the number of <li> rows (same structural line count).
   */
  function applyCartJsonToDrawer(cart) {
    if (!cart || !cart.items) return false;
    var items = cart.items;
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return false;
    var list = drawer.querySelector('.sidebar-cart-list');
    if (!list) return false;
    /* Filter out optimistic placeholders — they're handled separately by reconcileCartList */
    var lis = Array.prototype.slice.call(list.querySelectorAll('li[data-item-quantity]')).filter(function (li) {
      return li.getAttribute('data-optimistic') !== '1';
    });

    /* No existing rows to clone — fall back to section render. */
    if (lis.length === 0 && items.length > 0) return false;

    /* ---- Add rows when BOGO / scripts add items ---- */
    while (lis.length < items.length) {
      var template = lis[lis.length - 1];
      var clone = template.cloneNode(true);
      clone.querySelectorAll('[data-ej-qty-bound]').forEach(function (el) {
        el.removeAttribute('data-ej-qty-bound');
      });
      clone.removeAttribute('data-line-item-key');
      list.appendChild(clone);
      lis.push(clone);
    }

    /* ---- Remove excess rows ---- */
    while (lis.length > items.length) {
      var excess = lis.pop();
      if (excess.parentNode) excess.parentNode.removeChild(excess);
    }

    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var li = lis[i];
      var lineNum = i + 1;
      var fp = parseInt(item.final_price, 10);
      if (isNaN(fp)) fp = parseInt(item.price, 10) || 0;
      var flp = parseInt(item.final_line_price, 10);
      if (isNaN(flp)) flp = parseInt(item.line_price, 10) || 0;
      var olp = parseInt(item.original_line_price, 10);
      if (isNaN(olp)) olp = flp;
      var qty = parseInt(item.quantity, 10) || 0;

      if (item.key) li.setAttribute('data-line-item-key', item.key);
      li.setAttribute('data-item-price', String(fp));
      li.setAttribute('data-item-line-total', String(flp));
      li.setAttribute('data-original-line-total', String(olp));
      li.setAttribute('data-item-quantity', String(qty));

      var inp = li.querySelector('input[name="updates[]"]');
      if (inp) {
        inp.value = String(qty);
        inp.setAttribute('data-index', String(lineNum));
        inp.id = 'Drawer-quantity-' + String(lineNum);
      }

      var rm = li.querySelector('cart-remove-button');
      if (rm) {
        rm.setAttribute('data-index', String(lineNum));
        rm.id = 'CartDrawer-Remove-' + String(lineNum);
      }

      /* Update title + link (handles BOGO adding a different product). */
      var titleEl = li.querySelector('.title a');
      if (titleEl) {
        if (item.product_title) titleEl.textContent = item.product_title;
        if (item.url) titleEl.href = item.url;
      }

      /* Update image. */
      var img = li.querySelector('.cart-item__image');
      if (img && item.image) {
        var imgUrl = String(item.image);
        if (imgUrl.indexOf('width=') === -1) imgUrl += (imgUrl.indexOf('?') >= 0 ? '&' : '?') + 'width=200';
        if (img.src !== imgUrl) { img.src = imgUrl; img.alt = item.product_title || ''; }
      }

      /* Update variant options display. */
      var variantDl = li.querySelector('.dz-product-variants');
      if (variantDl && item.options_with_values) {
        var optDivs = variantDl.querySelectorAll('.product-option dd');
        var optIdx = 0;
        for (var ov = 0; ov < item.options_with_values.length && optIdx < optDivs.length; ov++) {
          var optVal = item.options_with_values[ov];
          if (optVal && optVal.value) {
            optDivs[optIdx].textContent = optVal.value + (ov < item.options_with_values.length - 1 ? ' / ' : '');
            optIdx++;
          }
        }
      }

      /* ── Discount-aware price display ── */
      var discountAmount = olp - flp;
      var isFree = (flp === 0 && discountAmount > 0);
      var hasDiscount = (discountAmount > 0);
      var discountTitle = '';
      if (item.line_level_discount_allocations && item.line_level_discount_allocations.length > 0) {
        discountTitle = item.line_level_discount_allocations[0].discount_application
          ? (item.line_level_discount_allocations[0].discount_application.title || '')
          : '';
      }

      var bogoLabel = discountTitle;

      li.setAttribute('data-discount-amount', String(discountAmount));
      li.setAttribute('data-is-free', String(isFree));
      li.setAttribute('data-discount-title', escapeHtml(discountTitle));

      var priceBlock = li.querySelector('.dz-price');
      if (priceBlock) {
        priceBlock.setAttribute('data-has-discount', String(hasDiscount));
        priceBlock.setAttribute('data-discount-amount', String(discountAmount));
        priceBlock.setAttribute('data-is-free', String(isFree));

        var comparePrice = item.variant && item.variant.compare_at_price
          ? parseInt(item.variant.compare_at_price, 10) : 0;
        var unitPrice = item.variant && item.variant.price
          ? parseInt(item.variant.price, 10) : (fp || 0);

        if (isFree) {
          priceBlock.innerHTML =
            '<span class="dz-price__mrp dz-price__mrp--bogo"><s>' + formatCartDrawerMoneyRupees(olp) + '</s></span>' +
            '<span class="dz-price__free">FREE</span>' +
            (bogoLabel ? '<span class="dz-price__bogo-tag">' + escapeHtml(bogoLabel) + '</span>' : '');
        } else if (hasDiscount) {
          var mrpVal = (comparePrice > unitPrice) ? (comparePrice * qty) : olp;
          priceBlock.innerHTML =
            '<span class="dz-price__mrp"><s>' + formatCartDrawerMoneyRupees(mrpVal) + '</s></span>' +
            '<span class="dz-price__sell">' + formatCartDrawerMoneyRupees(flp) + '</span>' +
            (bogoLabel ? '<span class="dz-price__bogo-info">' + escapeHtml(bogoLabel) + '</span>' : '');
        } else {
          var mrpHtml = '';
          if (comparePrice > unitPrice) {
            mrpHtml = '<span class="dz-price__mrp"><s>' + formatCartDrawerMoneyRupees(comparePrice * qty) + '</s></span>';
          }
          priceBlock.innerHTML = mrpHtml + '<span class="dz-price__sell">' + formatCartDrawerMoneyRupees(olp) + '</span>';
        }
      }
    }
    return true;
  }

  function cartLevelDiscountCents(cart) {
    var sum = 0;
    var apps = cart && cart.cart_level_discount_applications;
    if (!apps || !apps.length) return 0;
    for (var i = 0; i < apps.length; i++) {
      var a = parseInt(apps[i].total_allocated_amount, 10);
      if (!isNaN(a)) sum += a;
    }
    return sum;
  }

  /**
   * Cart-level discount implied by sum(original_line_price) − total_price (matches drawer Subtotal − Total).
   */
  function implicitCartLevelDiscountCents(cart) {
    if (!cart || cart.total_price == null) return -1;
    var total = parseInt(String(cart.total_price), 10);
    if (isNaN(total)) return -1;
    var sumOrig = sumOriginalLinePricesCart(cart);
    if (sumOrig < 0) return -1;
    return Math.max(0, sumOrig - total);
  }

  /**
   * Prefer API applications when they match implicit amount; otherwise trust line totals vs total_price.
   */
  function effectiveCartLevelDiscountCents(cart) {
    var rep = cartLevelDiscountCents(cart);
    var imp = implicitCartLevelDiscountCents(cart);
    if (imp < 0) return rep;
    var tol = 2;
    if (rep === 0 && imp > 0) return imp;
    if (rep > 0 && imp === 0) return rep;
    if (rep > 0 && imp > 0 && Math.abs(rep - imp) <= tol) return rep;
    if (rep > 0 && imp > 0) return imp;
    return rep;
  }

  /** Sum of line final_line_price (cents); -1 if any line missing price. */
  function sumFinalLinePricesCart(cart) {
    if (!cart || !cart.items) return -1;
    var items = cart.items;
    if (!items.length) return 0;
    var s = 0;
    for (var i = 0; i < items.length; i++) {
      var li = items[i];
      var raw = li.final_line_price != null ? li.final_line_price : li.line_price;
      var lp = parseInt(raw, 10);
      if (isNaN(lp)) return -1;
      s += lp;
    }
    return s;
  }

  /** Sum of line original_line_price (pre-discount line totals); -1 if any line missing. */
  function sumOriginalLinePricesCart(cart) {
    if (!cart || !cart.items) return -1;
    var items = cart.items;
    if (!items.length) return 0;
    var s = 0;
    for (var i = 0; i < items.length; i++) {
      var raw = items[i].original_line_price;
      var lp = parseInt(raw, 10);
      if (isNaN(lp)) return -1;
      s += lp;
    }
    return s;
  }

  /**
   * When POST and GET disagree on cart_level_discount_applications but match total + line sums,
   * pick the response whose reported discount is closer to implicit (sum(lines) − total_price).
   */
  function mergeCartAuthorityForFooter(fallback, cart) {
    if (!cart) return cart;
    if (!fallback || typeof fallback.total_price === 'undefined') return cart;
    var pT = parseInt(String(fallback.total_price), 10);
    var gT = parseInt(String(cart.total_price), 10);
    if (isNaN(pT) || isNaN(gT) || pT !== gT) return cart;
    var pD = cartLevelDiscountCents(fallback);
    var gD = cartLevelDiscountCents(cart);
    if (pD === gD) return cart;
    var sF = sumFinalLinePricesCart(fallback);
    var sG = sumFinalLinePricesCart(cart);
    if (sF < 0 || sG < 0 || sF !== sG) return cart;
    var imp = implicitCartLevelDiscountCents(cart);
    if (imp < 0) return cart;
    var distP = Math.abs(pD - imp);
    var distG = Math.abs(gD - imp);
    if (distP < distG) return fallback;
    if (distG < distP) return cart;
    return cart;
  }

  /** Match Liquid: subtotal = sum(original_line_price); total = total_price; savings = subtotal − total. */
  function formatDrawerMoneyFromCents(cents) {
    var n = Math.max(0, Math.round(cents));
    var whole = Math.floor(n / 100);
    var frac = n % 100;
    var r = whole.toLocaleString('en-IN');
    if (frac > 0) {
      r += '.' + (frac < 10 ? '0' : '') + frac;
    }
    var base = 'Rs. ' + r;
    if (
      currencyCodeEnabled &&
      typeof Shopify !== 'undefined' &&
      Shopify.currency &&
      Shopify.currency.active
    ) {
      return base + ' ' + String(Shopify.currency.active);
    }
    return base;
  }

  function applyFooterAndBadgeFromCartJson(cart, opts) {
    if (!cart) return;
    /* Don't let stale cart data overwrite optimistic footer during add */
    if (window._ejAddInFlight && !(opts && opts._fromAddHandler)) return;
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    var totalCents = parseInt(cart.total_price, 10);
    if (isNaN(totalCents)) return;
    var sumOrig = sumOriginalLinePricesCart(cart);
    var subtotalCents;
    var discountCents;
    if (sumOrig >= 0) {
      subtotalCents = sumOrig;
      discountCents = Math.max(0, sumOrig - totalCents);
    } else {
      discountCents = effectiveCartLevelDiscountCents(cart);
      subtotalCents = totalCents + (isNaN(discountCents) || discountCents < 0 ? 0 : discountCents);
    }
    var subStr = formatDrawerMoneyFromCents(subtotalCents);
    var totalStr = formatDrawerMoneyFromCents(totalCents);
    var subEl = drawer.querySelector('.cart-drawer__subtotal-value');
    var totalEl = drawer.querySelector('.cart-drawer__total-amount');
    var savingsRow = drawer.querySelector('[data-cart-drawer-savings-row]');
    var savingsVal = drawer.querySelector('.cart-drawer__discount-value');
    if (subEl) subEl.textContent = subStr;
    if (totalEl) totalEl.textContent = totalStr;
    if (savingsRow && savingsVal) {
      if (discountCents > 0) {
        savingsRow.hidden = false;
        savingsVal.textContent = '-' + formatDrawerMoneyFromCents(discountCents);
      } else {
        savingsRow.hidden = true;
        savingsVal.textContent = '-' + formatDrawerMoneyFromCents(0);
      }
    }
    var n = typeof cart.item_count === 'number' ? cart.item_count : 0;
    document.querySelectorAll('.header-eyejack__cart-badge').forEach(function (badge) {
      badge.textContent = String(n);
      badge.style.display = n > 0 ? '' : 'none';
    });
  }

  function dispatchCartRefreshAndUpdated(detail) {
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', { bubbles: true, detail: detail })
    );
    document.dispatchEvent(new CustomEvent('cart-drawer-updated'));
    if (typeof window.enableGokwikCart === 'function') {
      setTimeout(function () {
        window.enableGokwikCart();
      }, 0);
    }
  }

  /**
   * Subtotal / Savings / Total: apply from the cart data we already have.
   * No extra /cart.js fetch — the POST response contains everything needed.
   */
  function syncOrderSummaryFromCartFetch(fallbackDetail) {
    if (!fallbackDetail || typeof fallbackDetail.total_price === 'undefined') return;
    var cd = document.getElementById('CartDrawer');
    normalizeAddResponse(fallbackDetail);
    applyFooterAndBadgeFromCartJson(fallbackDetail);
    syncCartDrawerEmptyUi(cd);
    syncOfferCardsWithDrawerDom();
    dispatchCartRefreshAndUpdated(fallbackDetail);
  }

  /** Tier + dynamic offer UI aligned with footer in the same tick (before cart-drawer-updated rAF). */
  function syncOfferCardsWithDrawerDom() {
    var itemsEl = document.querySelector('cart-drawer-items');
    if (itemsEl) runOfferCard(itemsEl);
  }

  /**
   * Fetch fresh section HTML and only update DOM elements whose content
   * actually changed. Eliminates the visible flash that renderContents
   * causes when replacing identical content.
   */
  function silentSectionRefresh(opts) {
    var o = opts || {};

    /* If removals are still being processed, skip — the final sync
       will be triggered by ejOnAllRemovalsDone when the queue drains. */
    if (_ejRemovalProcessing || _ejRemovalQueue.length > 0) {
      if (o.onDone) o.onDone(false, null);
      return;
    }

    fetchCartDrawerSectionMarkup().then(function (json) {
      if (!json || !json['cart-drawer']) { if (o.onDone) o.onDone(false, null); return; }
      var html = json['cart-drawer'];
      var el = document.getElementById('CartDrawer');
      if (!el) { if (o.onDone) o.onDone(false, null); return; }

      var newDoc = new DOMParser().parseFromString(html, 'text/html');
      var newRoot = newDoc.querySelector('#CartDrawer') || newDoc.querySelector('.cart-drawer');
      if (!newRoot) { if (o.onDone) o.onDone(false, null); return; }

      /* Strip any items from server HTML whose line-item-key is in
         _ejRemovedLineKeys — these removals are confirmed server-side
         but the Set hasn't been cleared yet (cleared after this sync). */
      if (_ejRemovedLineKeys.size > 0) {
        _ejRemovedLineKeys.forEach(function (rk) {
          var zombie = newRoot.querySelector('li[data-line-item-key="' + rk + '"]');
          if (zombie) zombie.remove();
        });
      }

      /* Also strip any items currently marked as removing in the live DOM */
      el.querySelectorAll('li[data-ej-removing="1"]').forEach(function (li) { li.remove(); });

      /* ── Full innerHTML replace (like the reference theme) ── */
      var oldBogo = el.querySelector('.cart-drawer__offer-slot--b1g1');
      var newBogo = newRoot.querySelector('.cart-drawer__offer-slot--b1g1');
      if (oldBogo && newBogo) {
        oldBogo.innerHTML = newBogo.innerHTML;
      } else if (!oldBogo && newBogo) {
        var ic = el.querySelector('cart-drawer-items');
        if (ic) ic.insertBefore(newBogo.cloneNode(true), ic.firstChild);
      } else if (oldBogo && !newBogo && oldBogo.parentNode) {
        oldBogo.remove();
      }

      var oldList = el.querySelector('.sidebar-cart-list');
      var newList = newRoot.querySelector('.sidebar-cart-list');
      if (oldList && newList) {
        oldList.innerHTML = newList.innerHTML;
      }

      var oldFooter = el.querySelector('.dz-drawer-footer');
      var newFooter = newRoot.querySelector('.dz-drawer-footer');
      if (oldFooter && newFooter) {
        oldFooter.innerHTML = newFooter.innerHTML;
      } else if (!oldFooter && newFooter) {
        var di = el.querySelector('.drawer__inner');
        if (di) di.appendChild(newFooter.cloneNode(true));
      } else if (oldFooter && !newFooter && oldFooter.parentNode) {
        oldFooter.remove();
      }

      var oldEmpty = el.querySelector('.drawer-empty');
      var newEmpty = newRoot.querySelector('.drawer-empty');
      if (oldEmpty && newEmpty) {
        oldEmpty.hidden = newEmpty.hidden;
        el.classList.toggle('cart-drawer--empty', !newEmpty.hidden);
      }

      syncCartDrawerEmptyUi(el);
      syncOfferCardsWithDrawerDom();
      if (typeof window.enableGokwikCart === 'function') setTimeout(window.enableGokwikCart, 0);

      if (o.onDone) o.onDone(true, html);
    }).catch(function () {
      if (o.onDone) o.onDone(false, null);
    });
  }

  /**
   * Light path after JSON-only /cart/change: footer sync applies POST cart first, then GET /cart.js.
   */
  function finishCartUpdateLight(parsedState) {
    normalizeAddResponse(parsedState);
    return syncOrderSummaryFromCartFetch(parsedState);
  }

  /** Recover drawer UI if /cart/change fails after an optimistic update */
  function refreshCartDrawerAfterCartChangeError() {
    fetchCartDrawerSectionMarkup()
      .then(function (json) {
        if (!json || !json['cart-drawer']) return;
        var drawer = document.querySelector('cart-drawer');
        if (!drawer || typeof drawer.renderContents !== 'function') return;
        drawer.renderContents({ sections: { 'cart-drawer': json['cart-drawer'] } });
      })
      .catch(function () {});
  }

  /** Update line data-* + qty input before server responds (instant tier / offer UI) */
  function optimisticCartDrawerLine(lineIndex, qty, drawerEl) {
    var drawer = drawerEl || document.getElementById('CartDrawer');
    if (!drawer) return;
    var input = drawer.querySelector('input[name="updates[]"][data-index="' + String(lineIndex) + '"]');
    if (!input) return;
    var li = input.closest('li');
    if (!li) return;
    var q = parseInt(String(qty), 10);
    if (isNaN(q)) return;
    if (q <= 0) {
      var lineKey = li.getAttribute('data-line-item-key');
      if (lineKey) _ejRemovedLineKeys.add(lineKey);

      li.setAttribute('data-ej-removing', '1');
      li.style.pointerEvents = 'none';
      li.style.opacity = '0';
      li.style.transform = 'translateX(30px)';
      li.style.transition = 'opacity 0.15s ease, transform 0.15s ease';
      setTimeout(function () {
        li.style.overflow = 'hidden';
        li.style.height = li.offsetHeight + 'px';
        li.offsetHeight;
        li.style.transition = 'height 0.15s ease, padding 0.15s ease, margin 0.15s ease';
        li.style.height = '0';
        li.style.padding = '0';
        li.style.margin = '0';
      }, 100);
      setTimeout(function () {
        li.style.display = 'none';
      }, 250);
      return;
    }
    var prevQty = parseInt(li.getAttribute('data-item-quantity') || '0', 10);
    li.setAttribute('data-item-quantity', String(q));
    input.value = String(q);

    /* Update data attributes for tier calculations */
    var price = parseInt(li.getAttribute('data-item-price') || '0', 10);
    var prevLine = parseInt(li.getAttribute('data-item-line-total') || '0', 10);
    var prevOrig = parseInt(li.getAttribute('data-original-line-total') || '0', 10);
    var lineTotalCents;
    if (prevQty > 0 && prevLine > 0) {
      lineTotalCents = Math.round((prevLine * q) / prevQty);
    } else {
      lineTotalCents = Math.round(price * q);
    }
    li.setAttribute('data-item-line-total', String(lineTotalCents));
    var lineOrigCents;
    if (prevQty > 0 && prevOrig > 0) {
      lineOrigCents = Math.round((prevOrig * q) / prevQty);
    } else {
      lineOrigCents = lineTotalCents;
    }
    li.setAttribute('data-original-line-total', String(lineOrigCents));

    /* Only update price display if item has NO active discount.
       Items with discounts (FREE, BOGO) get correct prices from the
       section HTML fetch — optimistic price calc can't predict Shopify discounts. */
    var hasDiscount = li.getAttribute('data-is-free') === 'true' ||
      parseInt(li.getAttribute('data-discount-amount') || '0', 10) > 0;
    if (!hasDiscount) {
      var sellElOpt = li.querySelector('.dz-price__sell');
      if (sellElOpt) sellElOpt.textContent = formatCartDrawerMoneyRupees(lineOrigCents);
      updateCartLineMrpDisplay(li, q);
    }
  }

  /** Instant tier / offer / totals / badge (before /cart/change returns). */
  function applyOptimisticCartDrawerForLine(line, quantity) {
    var drawer = document.querySelector('cart-drawer');
    var drawerItemsEl = drawer && drawer.querySelector('cart-drawer-items');
    var lineNum = parseInt(String(line), 10);
    if (isNaN(lineNum) || !drawerItemsEl) return;
    var cd = document.getElementById('CartDrawer');
    optimisticCartDrawerLine(line, quantity, cd);
    optimisticCartDrawerFooterTotals(cd);
    optimisticCartDrawerHeaderBadge(cd);
    syncCartDrawerEmptyUi(cd, { _optimistic: true });
    requestAnimationFrame(function () {
      runOfferCard(drawerItemsEl);
    });
  }

  /** Remove several lines optimistically (lens + frame); higher line index first so data-index lookups stay valid. */
  function applyOptimisticCartDrawerForLines(lineNums) {
    var drawer = document.querySelector('cart-drawer');
    var drawerItemsEl = drawer && drawer.querySelector('cart-drawer-items');
    var cd = document.getElementById('CartDrawer');
    if (!cd || !drawerItemsEl || !lineNums || lineNums.length < 2) return;
    lineNums
      .slice()
      .sort(function (a, b) {
        return b - a;
      })
      .forEach(function (ln) {
        optimisticCartDrawerLine(ln, 0, cd);
      });
    optimisticCartDrawerFooterTotals(cd);
    optimisticCartDrawerHeaderBadge(cd);
    syncCartDrawerEmptyUi(cd, { _optimistic: true });
    requestAnimationFrame(function () {
      runOfferCard(drawerItemsEl);
    });
  }

  function formatCartDrawerMoneyRupees(cents) {
    var n = Math.max(0, Math.round(cents));
    var whole = Math.floor(n / 100);
    var frac = n % 100;
    var r = whole.toLocaleString('en-IN');
    if (frac > 0) {
      r += '.' + (frac < 10 ? '0' : '') + frac;
    }
    return 'Rs. ' + r;
  }

  /** MRP row = compare_at (unit) × qty; matches Liquid `ej_mrp_line`. */
  function updateCartLineMrpDisplay(li, qty) {
    if (!li) return;
    var unitCompare = parseInt(li.getAttribute('data-compare-at-unit-cents') || '0', 10);
    if (isNaN(unitCompare) || unitCompare <= 0) return;
    var q = parseInt(String(qty), 10);
    if (isNaN(q) || q <= 0) return;
    var mrpLineCents = unitCompare * q;
    var mrpEl = li.querySelector('.dz-price__mrp s');
    if (mrpEl) mrpEl.textContent = formatCartDrawerMoneyRupees(mrpLineCents);
  }

  function optimisticCartDrawerHeaderBadge(drawerEl) {
    var drawer = drawerEl || document.getElementById('CartDrawer');
    if (!drawer) return;
    var n = 0;
    drawer.querySelectorAll('input[name="updates[]"]').forEach(function (inp) {
      var v = parseInt(inp.value || '0', 10);
      if (!isNaN(v)) n += v;
    });
    document.querySelectorAll('.header-eyejack__cart-badge').forEach(function (badge) {
      badge.textContent = String(n);
      badge.style.display = n > 0 ? '' : 'none';
    });
  }

  /** Match sum of line totals (no cart-level discounts; server response corrects). */
  function optimisticCartDrawerFooterTotals(drawerEl) {
    var drawer = drawerEl || document.getElementById('CartDrawer');
    if (!drawer) return;
    var list = drawer.querySelector('.sidebar-cart-list');
    if (!list) return;
    var sum = 0;
    list.querySelectorAll('li[data-item-quantity]').forEach(function (li) {
      if (li.getAttribute('data-is-excluded') === 'true') return;
      var orig = parseInt(li.getAttribute('data-original-line-total') || '0', 10);
      var lt = parseInt(li.getAttribute('data-item-line-total') || '0', 10);
      var price = parseInt(li.getAttribute('data-item-price') || '0', 10);
      var q = parseInt(li.getAttribute('data-item-quantity') || '0', 10);
      if (orig > 0) sum += orig;
      else if (lt > 0) sum += lt;
      else sum += Math.round(price * (isNaN(q) ? 0 : q));
    });
    var s = formatDrawerMoneyFromCents(sum);
    var subEl = drawer.querySelector('.cart-drawer__subtotal-value');
    var totalEl = drawer.querySelector('.cart-drawer__total-amount');
    if (subEl) subEl.textContent = s;
    if (totalEl) totalEl.textContent = s;
    /* Cart-level savings unknown until server sync — hide row and clear text so nothing stale shows. */
    var savingsRow = drawer.querySelector('[data-cart-drawer-savings-row]');
    var savingsVal = drawer.querySelector('.cart-drawer__discount-value');
    if (savingsRow) savingsRow.hidden = true;
    if (savingsVal) savingsVal.textContent = '-' + formatDrawerMoneyFromCents(0);
  }

  /**
   * Lens selector & custom flows: refresh Eyejack cart drawer HTML and open it.
   * @param {object} [addResponse] - Optional /cart/add.js JSON that already includes sections['cart-drawer'].
   * @returns {Promise<boolean>}
   */
  window.eyejackOpenCartDrawerAfterAdd = function (addResponse) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') {
      return Promise.resolve(false);
    }

    function finish(state) {
      normalizeAddResponse(state);
      drawer.renderContents(state, { forceOpen: true });
      /* cart:refresh + footer: syncOrderSummaryFromCartFetch inside renderContents */
      return true;
    }

    if (
      addResponse &&
      addResponse.sections &&
      addResponse.sections['cart-drawer']
    ) {
      if (typeof addResponse.item_count !== 'number') {
        return fetchWithRetry(getCartJsUrl(), { headers: { Accept: 'application/json' } }, 2)
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            if (cart && typeof cart.item_count === 'number') {
              addResponse.item_count = cart.item_count;
            }
            return finish(addResponse);
          })
          .catch(function () {
            return finish(addResponse);
          });
      }
      return Promise.resolve(finish(addResponse));
    }

    return Promise.all([
      fetchWithRetry(getCartJsUrl(), { headers: { Accept: 'application/json' } }, 2).then(function (r) {
        return r.json();
      }),
      fetchCartDrawerSectionMarkup(),
    ])
      .then(function (results) {
        var cart = results[0];
        var sec = results[1] || {};
        var state = {
          item_count: cart && typeof cart.item_count === 'number' ? cart.item_count : undefined,
          sections: {},
        };
        if (sec['cart-drawer']) {
          state.sections['cart-drawer'] = sec['cart-drawer'];
        }
        return finish(state);
      })
      .catch(function () {
        return false;
      });
  };

  /** Any submit button name="add" (PDP, collection cards, sliders, etc.) */
  function beginAddToCartButtonState(button) {
    if (!button || button.getAttribute('data-ej-adding') === '1') return;
    button.setAttribute('data-ej-adding', '1');
    button.setAttribute('data-ej-add-btn-html', button.innerHTML);
    button.innerHTML = '<span class="ej-add-to-cart-loading">Adding...</span>';
  }

  function endAddToCartButtonState(button) {
    if (!button || button.getAttribute('data-ej-adding') !== '1') return;
    var html = button.getAttribute('data-ej-add-btn-html');
    if (html != null && html !== '') {
      button.innerHTML = html;
    }
    button.removeAttribute('data-ej-add-btn-html');
    button.removeAttribute('data-ej-adding');
  }

  function handleAjaxShopAddSubmit(e) {
    var form = e.target;
    if (!form || !form.getAttribute || form.nodeName !== 'FORM') return;
    if (form.id === 'CartDrawer-Form') return;
    if (form.closest && form.closest('cart-drawer')) {
      if (!form.classList.contains('shop-card__form')) return;
    }

    var sub = e.submitter;
    if (!sub) return;
    var isBuyNow =
      typeof sub.matches === 'function' && sub.matches('[data-buy-now]');
    if (sub.getAttribute('name') !== 'add' && !isBuyNow) return;

    var useAjax =
      form.classList.contains('ej-product-form') || form.classList.contains('shop-card__form');
    if (!useAjax) return;

    if (e.preventDefault) e.preventDefault();
    if (e.stopPropagation) e.stopPropagation();

    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') {
      window.__ejPendingCartAdd = { form: form, submitter: sub };
      return;
    }

    var item = formToCartLineItem(form);
    if (!item) {
      alert('Please select a product option.');
      return;
    }

    /* ── Step 1: Instant button feedback ── */
    beginAddToCartButtonState(sub);

    var gkBtn = document.querySelector('.gokwik-checkout button');
    window._ejAddInFlight = true;
    window._ejPendingCheckout = false;

    /* ── Step 2: INSTANT optimistic injection + open drawer ── */
    var oi = ejBuildOptimisticItem(form, item);
    var injected = ejInjectOptimisticItem(drawer, oi);

    /* Re-evaluate the offer card from the freshly injected rows so the item count
       reflects the new item immediately, without waiting for the server refresh. */
    var ejItemsEl = (drawer && drawer.querySelector('cart-drawer-items')) || document.querySelector('cart-drawer-items') || drawer;
    if (ejItemsEl && typeof window.cartOfferCardUpdate === 'function') {
      window.cartOfferCardUpdate(ejItemsEl);
    }

    if (drawer && !drawer.classList.contains('active')) {
      drawer.open();
    }

    /* ── Step 3: Background lean POST (no sections, fastest possible) ── */
    var leanBody = { items: [item] };

    fetch(getCartAddJsUrl(), fetchConfig('POST', { body: JSON.stringify(leanBody) }))
      .then(function (r) {
        return r.text().then(function (text) {
          var j = {};
          if (text) { try { j = JSON.parse(text); } catch (err) { j = {}; } }
          if (!r.ok || (j.status && Number(j.status) >= 400)) {
            throw new Error(cartAddErrorMessage(j));
          }
          if (j.errors) {
            throw new Error(cartAddErrorMessage(j));
          }
          return j;
        });
      })
      .then(function (addState) {
        normalizeAddResponse(addState);

        /* Update badge from real server count */
        if (typeof addState.item_count === 'number') {
          document.querySelectorAll('.header-eyejack__cart-badge').forEach(function (b) {
            b.textContent = addState.item_count;
            b.style.display = addState.item_count > 0 ? '' : 'none';
          });
        }

        /* Unlock checkout */
        window._ejAddInFlight = false;
        ejRestoreCheckoutButton();

        /* Button → "Added ✓" */
        if (sub) {
          sub.disabled = false;
          sub.innerHTML = '<span class="ej-add-to-cart-added">Added \u2713</span>';
          setTimeout(function () { endAddToCartButtonState(sub); }, 1200);
        }

        /* Fire pending checkout if user clicked it during the POST */
        if (window._ejPendingCheckout) {
          window._ejPendingCheckout = false;
          var pendingFn = window._ejPendingCheckoutFn;
          window._ejPendingCheckoutFn = null;
          setTimeout(function () {
            if (typeof pendingFn === 'function') {
              pendingFn();
              return;
            }
            var realGkBtn = document.querySelector('.gokwik-checkout button');
            if (realGkBtn && typeof window.onCheckoutClick === 'function') {
              window.onCheckoutClick(realGkBtn);
            } else {
              var checkoutForm = document.getElementById('CartDrawer-Form');
              if (checkoutForm) checkoutForm.submit();
            }
          }, 50);
          return;
        }

        /* ── Step 4: Wait for any pending removal POSTs, then reconcile ──
           If the user removed items right before adding, the server must
           finish processing those removals before we fetch section HTML.
           Otherwise the server returns stale HTML with the removed items. */
        window._ejRemovalsDonePromise.then(function () {
          silentSectionRefresh();
        });
      })
      .catch(function (err) {
        window._ejAddInFlight = false;
        window._ejPendingCheckout = false;
        window._ejPendingCheckoutFn = null;

        /* Roll back optimistic injection */
        if (injected && injected.el) {
          injected.el.remove();
        }
        if (injected && injected.updatedExisting && injected.existingLi) {
          var prevQty = parseInt(injected.existingLi.getAttribute('data-item-quantity') || '0', 10) - (injected.addedQty || 1);
          if (prevQty < 1) prevQty = 1;
          injected.existingLi.setAttribute('data-item-quantity', String(prevQty));
          var inp = injected.existingLi.querySelector('.quantity__input');
          if (inp) inp.value = String(prevQty);
        }
        ejRestoreBadge(injected);
        if (injected && injected.wasEmpty) {
          silentSectionRefresh();
        } else {
          optimisticCartDrawerFooterTotals(document.getElementById('CartDrawer'));
        }

        endAddToCartButtonState(sub);
        if (sub) sub.disabled = false;
        ejRestoreCheckoutButton();
        alert(err && err.message ? err.message : 'Could not add to cart.');
      });
  }

  /* ── Optimistic UI helpers ── */

  function ejEsc(str) {
    var d = document.createElement('div');
    d.textContent = str || '';
    return d.innerHTML;
  }

  /**
   * Build the GoKwik checkout wrapper HTML using the EXACT same CSS classes
   * and structure as gokwik-checkout.liquid. This ensures that when the server
   * HTML arrives during silentSectionRefresh, the innerHTML diff finds zero
   * differences and produces no DOM mutations / no flicker.
   */
  function ejEnsureGokwikStyles() {
    if (document.getElementById('ej-gokwik-opt-css')) return;
    var s = document.createElement('style');
    s.id = 'ej-gokwik-opt-css';
    s.textContent =
      '.gokwik-checkout-wrapper{position:relative;margin-top:12px;border-radius:12px;overflow:hidden;border:1px solid #e5e7eb}' +
      '.prepaid-offer-banner{display:flex;align-items:center;justify-content:center;gap:8px;background:#e8f5ec;border:none;border-radius:0;padding:4px 5px;margin:0}' +
      '.prepaid-offer-banner__icon{width:20px;height:20px;background:#166534;border-radius:50%;display:flex;align-items:center;justify-content:center;flex-shrink:0}' +
      '.prepaid-offer-banner__icon svg{width:11px;height:11px;color:#fff}' +
      '.prepaid-offer-banner__text{font-size:12px;font-weight:600;color:#14532d;line-height:1.3;text-align:center}' +
      '.prepaid-offer-banner__highlight{color:#14532d;font-weight:700}' +
      '.gokwik-checkout{position:relative;width:100%}' +
      '.gokwik-checkout button{width:100%;display:flex;align-items:center;justify-content:center;gap:8px;background:#1a202c!important;color:#fff!important;border:none!important;border-radius:0!important;padding:14px 44px!important;min-height:54px;cursor:pointer;position:relative;overflow:hidden;box-shadow:none!important}' +
      '.gokwik-checkout button::before{display:none}' +
      '.gokwik-checkout button.disabled{opacity:.55;cursor:not-allowed}' +
      '.gokwik-checkout .btn-text{display:flex;flex-direction:column;align-items:center!important}' +
      '.gokwik-checkout .btn-text span:first-child{font-size:14px;font-weight:700;letter-spacing:.02em}' +
      '.gokwik-checkout .secure-icon{position:absolute;left:14px;display:flex;align-items:center;color:#fff;opacity:.95}' +
      '.gokwik-checkout .secure-icon svg{width:14px;height:14px;stroke:currentColor}' +
      '.gokwik-checkout .arrow-icon{position:absolute;right:14px;display:flex;align-items:center;color:#fff}' +
      '.gokwik-checkout .arrow-icon svg{width:16px;height:16px;stroke:currentColor}' +
      '.gokwik-checkout .addloadr{position:absolute;inset:0;background:inherit;display:flex;align-items:center;justify-content:center;border-radius:inherit}' +
      '.gokwik-checkout .cir-loader{font-size:13px;font-weight:600}' +
      '.gokwik-checkout-wrapper .gokwik-checkout button>span.btn-text{align-items:center!important}';
    document.head.appendChild(s);
  }

  function ejBuildGokwikCheckoutHtml() {
    var existing = document.querySelector('.gokwik-checkout-wrapper');
    if (existing) {
      return existing.outerHTML;
    }
    ejEnsureGokwikStyles();
    return '<div class="gokwik-checkout-wrapper">' +
      '<div class="prepaid-offer-banner">' +
        '<div class="prepaid-offer-banner__icon">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">' +
            '<path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"/>' +
          '</svg>' +
        '</div>' +
        '<span class="prepaid-offer-banner__text">' +
          'Get <span class="prepaid-offer-banner__highlight">Extra 5% OFF</span> on Prepaid Orders' +
        '</span>' +
      '</div>' +
      '<div class="gokwik-checkout">' +
        '<button type="button" class="btn btn--primary disabled" disabled onclick="onCheckoutClick(this)">' +
          '<span class="secure-icon">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
              '<rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>' +
              '<path d="M7 11V7a5 5 0 0 1 10 0v4"/>' +
            '</svg>' +
          '</span>' +
          '<span class="btn-text">' +
            '<span>Proceed to Checkout</span>' +
          '</span>' +
          '<span class="arrow-icon">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">' +
              '<path d="M5 12h14M12 5l7 7-7 7"/>' +
            '</svg>' +
          '</span>' +
          '<div style="display:none" class="addloadr" id="btn-loader">' +
            '<div class="cir-loader">Loading..</div>' +
          '</div>' +
        '</button>' +
      '</div>' +
    '</div>';
  }

  function ejBuildOptimisticItem(form, item) {
    var data = {
      id: item.id,
      qty: item.quantity || 1,
      title: '',
      image: '',
      price: '',
      priceCents: 0,
      compare: '',
      compareCents: 0,
      url: window.location.pathname
    };

    /* Detect context: collection/card vs PDP */
    var isCard = form.classList.contains('shop-card__form');
    var card = isCard ? form.closest('.shop-card') || form.closest('li') : null;

    if (card) {
      /* ── Collection card: extract from the card element ── */
      var cardTitle = card.querySelector('.shop-card__title');
      if (cardTitle) data.title = cardTitle.textContent.trim();

      var cardImg = card.querySelector('.shop-card__image');
      if (cardImg) data.image = (cardImg.currentSrc || cardImg.src || '').split('?')[0] + '?width=200';

      var cardPrice = card.querySelector('.shop-card__price');
      if (cardPrice) {
        data.price = cardPrice.textContent.trim();
        data.priceCents = parseInt(cardPrice.textContent.replace(/[^\d]/g, ''), 10) || 0;
      }

      var cardCompare = card.querySelector('.shop-card__price--compare');
      if (cardCompare && cardCompare.textContent.trim()) {
        data.compare = cardCompare.textContent.trim();
        data.compareCents = parseInt(cardCompare.textContent.replace(/[^\d]/g, ''), 10) || 0;
      }

      var cardLink = card.querySelector('.shop-card__link') || card.querySelector('a[href*="/products/"]');
      if (cardLink) data.url = cardLink.getAttribute('href') || data.url;

    } else {
      /* ── PDP: extract from main product section ── */
      var root = document.querySelector('[data-main-product]') || document.querySelector('.eyejack-pdp') || document;

      var titleEl = root.querySelector('.ej-title') || root.querySelector('h1');
      if (titleEl) data.title = titleEl.textContent.trim();

      var imgEl = root.querySelector('.ej-media__slide img') || root.querySelector('.product__media img') || root.querySelector('[data-product-gallery] img');
      if (imgEl) data.image = (imgEl.currentSrc || imgEl.src || '').split('?')[0] + '?width=200';

      var priceEl = root.querySelector('[data-inline-price-current]') || root.querySelector('.price-block__current');
      if (priceEl) {
        data.price = priceEl.textContent.trim();
        data.priceCents = parseInt(priceEl.textContent.replace(/[^\d]/g, ''), 10) || 0;
      }

      var cmpEl = root.querySelector('[data-inline-price-compare]') || root.querySelector('.price-block__compare');
      if (cmpEl && cmpEl.textContent.trim()) {
        data.compare = cmpEl.textContent.trim();
        data.compareCents = parseInt(cmpEl.textContent.replace(/[^\d]/g, ''), 10) || 0;
      }
    }

    return data;
  }

  function ejInjectOptimisticItem(drawer, oi) {
    var cartRoot = drawer.querySelector('#CartDrawer') || drawer;
    var drawerInner = cartRoot.querySelector('.drawer__inner') || cartRoot;
    var list = cartRoot.querySelector('.sidebar-cart-list');
    var hasItems = list && list.querySelector('li');
    var wasEmpty = !hasItems;

    /* Always clear the empty state overlay */
    var emptyEl = cartRoot.querySelector('.drawer-empty');
    if (emptyEl) emptyEl.hidden = true;
    if (cartRoot.classList) cartRoot.classList.remove('cart-drawer--empty');

    /* ── Check if variant is already in cart — update quantity instead of adding duplicate ── */
    if (hasItems && oi.id) {
      var existingInput = list.querySelector('input[data-quantity-variant-id="' + String(oi.id) + '"]');
      if (existingInput) {
        var existingLi = existingInput.closest('li');
        if (existingLi && existingLi.getAttribute('data-optimistic') !== '1') {
          /* Found existing item — update its quantity optimistically */
          var currentQty = parseInt(existingLi.getAttribute('data-item-quantity') || '0', 10) || 0;
          var newQty = currentQty + (oi.qty || 1);
          existingLi.setAttribute('data-item-quantity', String(newQty));
          existingInput.value = String(newQty);
          
          /* Update price display */
          var priceCents = parseInt(existingLi.getAttribute('data-item-price') || '0', 10) || 0;
          var newLineCents = priceCents * newQty;
          existingLi.setAttribute('data-item-line-total', String(newLineCents));
          existingLi.setAttribute('data-original-line-total', String(newLineCents));
          var sellEl = existingLi.querySelector('.dz-price__sell');
          if (sellEl) sellEl.textContent = formatCartDrawerMoneyRupees(newLineCents);
          
          /* Update MRP if exists */
          var compareCents = parseInt(existingLi.getAttribute('data-compare-at-unit-cents') || '0', 10) || 0;
          if (compareCents > 0) {
            var mrpEl = existingLi.querySelector('.dz-price__mrp s');
            if (mrpEl) mrpEl.textContent = formatCartDrawerMoneyRupees(compareCents * newQty);
          }
          
          /* Update badge */
          var badge = document.querySelector('.header-eyejack__cart-badge');
          var prevCount = 0;
          if (badge) {
            prevCount = parseInt(badge.textContent, 10) || 0;
            badge.textContent = String(prevCount + (oi.qty || 1));
            badge.style.display = '';
          }
          
          /* Update footer totals */
          optimisticCartDrawerFooterTotals(cartRoot);
          
          /* Return with flag indicating we updated existing (no new element to remove on error) */
          return { el: null, wasEmpty: false, prevCount: prevCount, updatedExisting: true, existingLi: existingLi, addedQty: oi.qty || 1 };
        }
      }
    }

    if (!hasItems) {
      /* ── Cart is visually empty: ensure BOGO bar, form/list, and footer exist ── */

      var itemsContainer = cartRoot.querySelector('cart-drawer-items');
      if (!itemsContainer) itemsContainer = cartRoot.querySelector('.dz-drawer-content');
      if (!itemsContainer) return null;

      /* Remove stale BOGO slot if left over from a previous server render */
      var oldBogo = cartRoot.querySelector('.cart-drawer__offer-slot--b1g1');
      if (oldBogo) oldBogo.remove();

      /* BOGO bar */
      var bogoSlot = document.createElement('div');
      bogoSlot.className = 'cart-drawer__offer-slot cart-drawer__offer-slot--b1g1';
      bogoSlot.innerHTML = '<div class="b1g1-offer-card" data-b1g1-card data-b1g1-applied="false" data-required="2" data-current="1">' +
        '<div class="b1g1-offer-card__header">' +
          '<div class="b1g1-offer-card__icon" data-b1g1-icon>' +
            '<svg width="40" height="40" viewBox="0 0 40 40" fill="none"><circle cx="20" cy="20" r="20" fill="#111"/>' +
            '<path d="M26 17v8a1 1 0 01-1 1H15a1 1 0 01-1-1v-8" stroke="#fff" stroke-width="1.5" stroke-linecap="round"/>' +
            '<path d="M28 14H12v3h16v-3z" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
            '<path d="M20 26v-12" stroke="#fff" stroke-width="1.5"/>' +
            '<path d="M20 14s-1-3-3.5-3c-1.38 0-2.5 1.12-2.5 2.5s1.12 2.5 2.5 2.5" stroke="#fff" stroke-width="1.5" stroke-linecap="round"/>' +
            '<path d="M20 14s1-3 3.5-3c1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5" stroke="#fff" stroke-width="1.5" stroke-linecap="round"/>' +
          '</svg></div>' +
          '<div class="b1g1-offer-card__text">' +
            '<h3 class="b1g1-offer-card__title" data-b1g1-title>Buy 1 Get 1 Free!</h3>' +
            '<p class="b1g1-offer-card__subtitle" data-b1g1-subtitle>Add 1 more item to unlock free item</p>' +
          '</div>' +
        '</div>' +
        '<div class="b1g1-offer-card__progress"><div class="b1g1-offer-card__bar"><div class="b1g1-offer-card__bar-fill" data-b1g1-fill style="width:50%"></div></div></div>' +
        '<div class="b1g1-offer-card__footer">' +
          '<span class="b1g1-offer-card__count" data-b1g1-count><strong>1</strong> of 2 items added</span>' +
          '<div class="b1g1-offer-card__dots">' +
            '<span class="b1g1-offer-card__dot b1g1-offer-card__dot--filled" data-b1g1-dot="1">1</span>' +
            '<span class="b1g1-offer-card__dot" data-b1g1-dot="2">2</span>' +
          '</div>' +
        '</div>' +
        '</div>';
      itemsContainer.insertBefore(bogoSlot, itemsContainer.firstChild);

      /* Reuse existing form + list or create them */
      var formEl = cartRoot.querySelector('#CartDrawer-Form');
      if (!formEl) {
        formEl = document.createElement('form');
        formEl.id = 'CartDrawer-Form';
        formEl.className = 'cart__contents cart-drawer__form';
        formEl.method = 'post';
        formEl.action = '/cart';
        itemsContainer.appendChild(formEl);
      }

      if (!list) {
        list = document.createElement('ul');
        list.className = 'sidebar-cart-list';
        formEl.appendChild(list);
      }

      /* Remove stale footer if left over */
      var oldFooter = cartRoot.querySelector('.dz-drawer-footer');
      if (oldFooter) oldFooter.remove();

      /* Footer: subtotal + total + checkout — uses exact same CSS classes
         as cart-drawer.liquid + gokwik-checkout.liquid so the server HTML
         diff produces zero changes on reconcile. */
      var priceStr = oi.price || 'Rs. 0';
      var footer = document.createElement('div');
      footer.className = 'dz-drawer-footer cart-drawer__footer';
      footer.innerHTML = '<div class="cart-drawer__footer-summary-stack">' +
        '<div class="cart-drawer__order-summary">' +
          '<div class="cart-drawer__subtotal-row cart-drawer__discount-row--split">' +
            '<span class="cart-drawer__discount-label">Subtotal</span>' +
            '<span class="cart-drawer__subtotal-value">' + ejEsc(priceStr) + '</span>' +
          '</div>' +
          '<div class="cart-drawer__discount-row cart-drawer__discount-row--split" role="status" data-cart-drawer-savings-row hidden>' +
            '<span class="cart-drawer__discount-label">Savings</span>' +
            '<span class="cart-drawer__discount-value">-Rs. 0</span>' +
          '</div>' +
          '<div class="cart-drawer__total-row">' +
            '<span class="cart-drawer__total-label">Total:</span>' +
            '<span class="cart-drawer__total-amount">' + ejEsc(priceStr) + '</span>' +
          '</div>' +
        '</div>' +
        '<div class="dz-cart-btns">' + ejBuildGokwikCheckoutHtml() + '</div>' +
      '</div>';
      drawerInner.appendChild(footer);

      /* Enable the GoKwik checkout button in the optimistic footer.
         The button starts disabled (matching gokwik-checkout.liquid default).
         enableGokwikCart() will be called after silentSectionRefresh. For now,
         just enable it so the user can click checkout while the POST completes. */
      var optGkBtn = footer.querySelector('.gokwik-checkout button');
      if (optGkBtn) {
        optGkBtn.disabled = false;
        optGkBtn.classList.remove('disabled');
      }
      if (typeof window.enableGokwikCart === 'function') {
        setTimeout(window.enableGokwikCart, 0);
      }
    }

    /* ── Build the <li> matching real cart-drawer.liquid structure ── */
    var li = document.createElement('li');
    li.setAttribute('data-item-quantity', String(oi.qty));
    li.setAttribute('data-optimistic', '1');
    var oiPaise = (oi.priceCents || 0);
    /* priceCents is parsed from text like "Rs. 999" → parseInt("999") = 999.
       Shopify stores prices in paise, so we need ×100.  Only skip when the
       *numeric* portion contains a decimal (e.g. "999.50" → 99950 paise).
       Strip the "Rs. " prefix first so its period doesn't confuse the check. */
    var oiRawPrice = (oi.price || '').replace(/^[^\d]*/, '');
    if (oiRawPrice.indexOf('.') === -1) oiPaise = oiPaise * 100;
    li.setAttribute('data-unit-price-cents', String(oiPaise));
    li.setAttribute('data-item-price', String(oiPaise));
    li.setAttribute('data-original-line-total', String(oiPaise * (oi.qty || 1)));
    li.setAttribute('data-item-line-total', String(oiPaise * (oi.qty || 1)));
    li.setAttribute('data-is-free', 'false');
    li.setAttribute('data-discount-amount', '0');
    if (oi.compareCents > 0) {
      var oiComparePaise = oi.compareCents;
      var oiRawCompare = (oi.compare || '').replace(/^[^\d]*/, '');
      if (oiRawCompare.indexOf('.') === -1) oiComparePaise = oiComparePaise * 100;
      li.setAttribute('data-compare-at-unit-cents', String(oiComparePaise));
    }

    var existingCount = list.querySelectorAll('li[data-item-quantity]').length;
    var oiLineIdx = existingCount + 1;
    var oiHandle = '';
    var oiUrlParts = (oi.url || '').split('/products/');
    if (oiUrlParts[1]) oiHandle = oiUrlParts[1].split('/')[0].split('?')[0];

    var html = '<div class="dz-cart-item">';
    if (oi.image) {
      html += '<div class="dz-media"><a href="' + ejEsc(oi.url) + '" class="cart-item__link" tabindex="-1"><img class="cart-item__image" src="' + ejEsc(oi.image) + '" alt="" width="200" height="200" loading="eager"></a></div>';
    }
    html += '<div class="dz-content">';
    html += '<h3 class="title"><a href="' + ejEsc(oi.url) + '">' + ejEsc(oi.title) + '</a></h3>';
    html += '<div class="dz-price" data-b1g1-price-block data-has-discount="false" data-discount-amount="0" data-is-free="false">';
    if (oi.compare) {
      html += '<span class="dz-price__mrp"><s>' + ejEsc(oi.compare) + '</s></span> ';
    }
    html += '<span class="dz-price__sell">' + ejEsc(oi.price) + '</span>';
    html += '</div>';
    html += '<quantity-popover><div class="cart-item__quantity-wrapper quantity-popover-wrapper">';
    html += '<div class="quantity-popover-container"><quantity-input class="quantity cart-quantity">';
    html += '<button class="quantity__button" name="minus" type="button"><span class="svg-wrapper"><svg width="12" height="2" viewBox="0 0 12 2" fill="currentColor" aria-hidden="true"><rect width="12" height="2" rx="1"/></svg></span></button>';
    html += '<input class="quantity__input" type="number" readonly inputmode="none" autocomplete="off" data-quantity-variant-id="' + ejEsc(String(oi.id)) + '" name="updates[]" value="' + oi.qty + '" min="0" step="1" data-index="' + oiLineIdx + '" id="Drawer-quantity-' + oiLineIdx + '">';
    html += '<button class="quantity__button" name="plus" type="button"><span class="svg-wrapper"><svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" aria-hidden="true"><path d="M5 0h2v5h5v2H7v5H5V7H0V5h5V0z"/></svg></span></button>';
    html += '</quantity-input></div>';
    if (oiHandle) {
      html += '<button type="button" class="button button--tertiary cart-drawer__select-lens" data-open-lens-from-cart data-variant-id="' + ejEsc(String(oi.id)) + '" data-product-handle="' + ejEsc(oiHandle) + '" data-variant-sku="" aria-label="Select lenses for ' + ejEsc(oi.title) + '">Select lens</button>';
    }
    html += '<cart-remove-button id="CartDrawer-Remove-' + oiLineIdx + '" data-index="' + oiLineIdx + '">';
    html += '<button type="button" class="button button--tertiary cart-remove-button" aria-label="Remove ' + ejEsc(oi.title) + '" data-variant-id="' + ejEsc(String(oi.id)) + '">';
    html += '<span class="svg-wrapper"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M3 6h18M8 6V4h8v2M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6M10 11v6M14 11v6"/></svg></span>';
    html += '</button></cart-remove-button>';
    html += '</div></quantity-popover>';
    html += '</div></div>';

    li.innerHTML = html;

    if (list.firstChild) {
      list.insertBefore(li, list.firstChild);
    } else {
      list.appendChild(li);
    }

    /* Update cart badge */
    var prevCount = 0;
    var badge = document.querySelector('.header-eyejack__cart-badge');
    if (badge) {
      prevCount = parseInt(badge.textContent, 10) || 0;
      badge.textContent = String(prevCount + oi.qty);
      badge.style.display = '';
    }

    /* Update footer totals to include the new item */
    optimisticCartDrawerFooterTotals(cartRoot);

    return { el: li, wasEmpty: wasEmpty, prevCount: prevCount };
  }

  function ejRestoreBadge(injected) {
    if (!injected) return;
    var badge = document.querySelector('.header-eyejack__cart-badge');
    if (badge && typeof injected.prevCount === 'number') {
      badge.textContent = String(injected.prevCount);
      badge.style.display = injected.prevCount > 0 ? '' : 'none';
    }
  }

  document.addEventListener('submit', handleAjaxShopAddSubmit, true);

  /**
   * PDP Buy Now: same AJAX add + drawer as ATC, but loading state on the Buy Now button (not Add to cart).
   */
  window.__ejHandleProductBuyNow = function (form, buyNowBtn) {
    if (!form || !buyNowBtn) return;
    handleAjaxShopAddSubmit({ target: form, submitter: buyNowBtn });
  };

  window.__ejDispatchPendingCartAdd = function () {
    var p = window.__ejPendingCartAdd;
    if (!p || !p.form || !p.submitter) return;
    window.__ejPendingCartAdd = null;
    handleAjaxShopAddSubmit({ target: p.form, submitter: p.submitter });
  };

  /* ---------- Custom elements ---------- */

  if (!customElements.get('quantity-input')) {
    customElements.define(
      'quantity-input',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ejQtyBound === '1') return;
          this.dataset.ejQtyBound = '1';
          var self = this;
          this.input = this.querySelector('input[name="updates[]"]');
          this.changeEvent = new Event('change', { bubbles: true });
          if (this.input) {
            this.input.addEventListener(
              'wheel',
              function (e) {
                e.preventDefault();
              },
              { passive: false }
            );
          }
          this.querySelectorAll('.quantity__button').forEach(function (btn) {
            btn.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopImmediatePropagation();
              if (btn.disabled || window._ejQtyChangeInFlight) return;
              if (!self.input) return;
              var name = btn.getAttribute('name');
              var v = parseInt(self.input.value, 10) || 0;
              var step = parseInt(self.input.step, 10) || 1;
              var min = parseInt(self.input.min, 10);
              var max = self.input.max ? parseInt(self.input.max, 10) : Infinity;
              if (name === 'plus') v = Math.min(max, v + step);
              else if (name === 'minus') v = Math.max(min >= 0 ? min : 0, v - step);
              self.input.value = v;

              clearTimeout(self._qtyDebounce);
              self._qtyDebounce = setTimeout(function () {
                if (window._ejQtyChangeInFlight) return;
                var finalValue = parseInt(self.input.value, 10) || 0;
                var variantId = self.input.getAttribute('data-quantity-variant-id');
                var lineIndex = self.input.dataset.index;
                var items = self.closest('cart-drawer-items');
                if (items && typeof items.updateQuantity === 'function') {
                  items.updateQuantity(lineIndex, String(finalValue), null, variantId);
                } else {
                  self.input.dispatchEvent(self.changeEvent);
                }
              }, 120);
            });
          });
        }
      }
    );
  }

  if (!customElements.get('cart-remove-button')) {
    customElements.define(
      'cart-remove-button',
      class extends HTMLElement {
        connectedCallback() {
          var root = this;
          var btn = this.querySelector('button');
          if (!btn) return;
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            var items = root.closest('cart-drawer-items');
            if (items && items.updateQuantity) {
              items.updateQuantity(root.dataset.index, 0);
            }
          });
        }
      }
    );
  }

  if (!customElements.get('quantity-popover')) {
    customElements.define(
      'quantity-popover',
      class extends HTMLElement {
        connectedCallback() {}
      }
    );
  }

  if (!customElements.get('volume-pricing')) {
    customElements.define(
      'volume-pricing',
      class extends HTMLElement {
        connectedCallback() {}
      }
    );
  }

  class CartItems extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ejCartChangeBound === '1') return;
      this.dataset.ejCartChangeBound = '1';
      this.addEventListener('change', function (e) {
        if (e.target.matches && e.target.matches('input[name="updates[]"]')) {
          this._handleChange(e);
        }
      }.bind(this));
    }

    _handleChange(event) {
      if (window._ejQtyChangeInFlight) return;
      var input = event.target;
      var variantId = input.getAttribute('data-quantity-variant-id');
      this.updateQuantity(input.dataset.index, input.value, input.getAttribute('name'), variantId);
    }

    getSectionsToRender() {
      return [];
    }

    updateQuantity(line, quantity, name, variantId) {
      var drawer = document.querySelector('cart-drawer');
      var drawerItemsEl = drawer && drawer.querySelector('cart-drawer-items');
      var lineNum = parseInt(String(line), 10);
      var qty = parseInt(String(quantity), 10);
      var cd = document.getElementById('CartDrawer');

      /* Resolve variant ID from line if not provided */
      if (!variantId && !isNaN(lineNum) && cd) {
        variantId = getVariantIdForLine(cd, lineNum);
      }

      /* ──────────────────────────────────────────────────────────
         REMOVALS (qty === 0): use line item key for precision
         ────────────────────────────────────────────────────────── */
      if (qty === 0 && !isNaN(lineNum)) {
        /* Resolve the line item key for this specific line */
        var removeLineKey = null;
        if (cd) {
          var removeInput = cd.querySelector('input[name="updates[]"][data-index="' + lineNum + '"]');
          var removeLi = removeInput && removeInput.closest('li');
          if (removeLi) removeLineKey = removeLi.getAttribute('data-line-item-key');
        }

        var removePairPlan = resolveRemovePairFromDomBeforeOptimistic(lineNum);

        if (removePairPlan && removePairPlan.mode === 'multi' && removePairPlan.lines && removePairPlan.lines.length > 1) {
          var variantIdsToRemove = [];
          removePairPlan.lines.forEach(function (ln) {
            var vid = getVariantIdForLine(cd, ln);
            if (vid) {
              variantIdsToRemove.push(vid);
            }
          });
          applyOptimisticCartDrawerForLines(removePairPlan.lines);
          _ejBatchRemoval(variantIdsToRemove, drawer);
          return;
        }

        if (removePairPlan && removePairPlan.mode === 'fetch') {
          var primaryVid = variantId || getVariantIdForLine(cd, lineNum);
          if (primaryVid) {
            _ejBatchRemovalWithPairLookup(primaryVid ? [primaryVid] : [], primaryVid, drawer);
          } else {
            _ejBatchRemovalFallbackLine(lineNum, drawer);
          }
          applyOptimisticCartDrawerForLine(line, quantity);
          return;
        }

        /* Single line removal — use line item key with /cart/change.js for precision.
           This only removes THIS specific line, not other lines with the same variant. */
        applyOptimisticCartDrawerForLine(line, quantity);
        if (removeLineKey) {
          _ejRemoveSingleLineByKey(removeLineKey, drawer);
        } else if (variantId) {
          _ejBatchRemoval([variantId], drawer);
        } else {
          _ejBatchRemovalFallbackLine(lineNum, drawer);
        }
        return;
      }

      /* ──────────────────────────────────────────────────────────
         QUANTITY CHANGES (qty > 0): single POST, fully locked
         ────────────────────────────────────────────────────────── */
      if (window._ejQtyChangeInFlight) return;
      window._ejQtyChangeInFlight = true;

      /* Cancel any pending safety-net refresh */
      clearTimeout(window._ejSafetyNetTimer);
      
      var gkBtn = document.querySelector('.gokwik-checkout button');
      if (gkBtn) { gkBtn.disabled = true; gkBtn.classList.add('disabled'); }

      /* Disable ALL quantity buttons to prevent race conditions */
      if (cd) {
        cd.querySelectorAll('.quantity__button').forEach(function (b) { b.disabled = true; });
      }

      applyOptimisticCartDrawerForLine(line, quantity);

      /* Use /cart/change.js with the line item key (id) for precision.
         The key uniquely identifies a line item even when multiple lines
         share the same variant (e.g. BOGO splits). Falls back to line index. */
      var lineItemKey = null;
      if (cd && !isNaN(lineNum)) {
        var lineInput = cd.querySelector('input[name="updates[]"][data-index="' + lineNum + '"]');
        var lineLi = lineInput && lineInput.closest('li');
        if (lineLi) lineItemKey = lineLi.getAttribute('data-line-item-key');
      }
      var postBody;
      if (lineItemKey) {
        postBody = JSON.stringify({ id: lineItemKey, quantity: qty });
      } else {
        postBody = JSON.stringify({ line: lineNum, quantity: qty });
      }

      fetch(getCartChangeJsUrl(), fetchConfig('POST', { body: postBody }))
      .then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error(j.message || j.description || 'Cart error');
          return j;
        });
      })
      .then(function (state) {
        normalizeAddResponse(state);
        if (state.item_count === 0) {
          finishCartUpdateLight(state);
          return;
        }
        return fetchCartDrawerSectionMarkup().then(function (sec) {
          var merged = state || {};
          merged.sections = merged.sections || {};
          if (sec && sec['cart-drawer']) merged.sections['cart-drawer'] = sec['cart-drawer'];
          normalizeAddResponse(merged);
          if (drawer && drawer.renderContents) drawer.renderContents(merged);
          finishCartUpdateLight(merged);
        }).catch(function () {
          applyCartJsonToDrawer(state);
          finishCartUpdateLight(state);
        });
      })
      .catch(function () {
        refreshCartDrawerAfterCartChangeError();
      })
      .finally(function () {
        window._ejQtyChangeInFlight = false;
        if (gkBtn) { gkBtn.disabled = false; gkBtn.classList.remove('disabled'); }
        var freshCd = document.getElementById('CartDrawer');
        if (freshCd) {
          freshCd.querySelectorAll('.quantity__button').forEach(function (b) { b.disabled = false; });
        }
        /* Safety-net refresh to catch late discount recalculations */
        window._ejSafetyNetTimer = setTimeout(function () {
          if (window._ejAddInFlight || window._ejRemovalsInFlight || window._ejQtyChangeInFlight) return;
          silentSectionRefresh();
        }, 250);
      });
    }
  }

  /* ════════════════════════════════════════════════════════════════
     REMOVAL SYSTEM — Serial Queue (same pattern as reference cart)
     ─────────────────────────────────────────────────────────────
     Modelled after the working reference implementation:
     1. User taps remove → item slides out & is removed from DOM
     2. Removal request is added to a SERIAL QUEUE
     3. Queue processes ONE request at a time (no parallel POSTs)
     4. When queue is fully drained → single syncWithServer()
     No counting, no flight flags, no race conditions.
     ════════════════════════════════════════════════════════════════ */

  var _ejRemovalQueue = [];
  var _ejRemovalProcessing = false;
  var _ejRemovedKeys = new Set();

  /* Line item keys of removed items. Unlike _ejRemovedKeys (cleared when
     queue drains), this persists until the final section sync completes.
     Every code path that writes server HTML into the DOM checks this Set
     and strips matching <li> elements before applying, preventing zombies. */
  var _ejRemovedLineKeys = new Set();

  /* Promise that resolves when the removal queue is fully drained.
     Add-to-cart waits on this so it fetches section HTML only after
     the server has processed every pending removal. */
  window._ejRemovalsDonePromise = window._ejRemovalsDonePromise || Promise.resolve();
  window._ejRemovalsDoneResolve = window._ejRemovalsDoneResolve || null;

  function ejEnsureRemovalsDonePromise() {
    if (!window._ejRemovalsDoneResolve) {
      window._ejRemovalsDonePromise = new Promise(function (resolve) {
        window._ejRemovalsDoneResolve = resolve;
      });
    }
  }

  function ejResolveRemovalsDone() {
    if (window._ejRemovalsDoneResolve) {
      window._ejRemovalsDoneResolve();
      window._ejRemovalsDoneResolve = null;
      window._ejRemovalsDonePromise = Promise.resolve();
    }
  }

  /**
   * Enqueue a cart removal. Duplicates for the same key are skipped.
   * @param {string} key - line item key (for /cart/change.js { id: key, quantity: 0 })
   */
  function ejQueueRemoval(key) {
    if (!key) return;
    if (_ejRemovedKeys.has(key)) return;
    _ejRemovedKeys.add(key);
    _ejRemovalQueue.push({ key: key });
    window._ejRemovalsInFlight = _ejRemovalQueue.length;
    ejEnsureRemovalsDonePromise();
    ejProcessRemovalQueue();
  }

  /**
   * Enqueue removals by variant IDs (for batch /cart/update.js).
   * Used when we only know variant IDs, not line keys.
   */
  function ejQueueBatchRemovalByVids(variantIds) {
    if (!variantIds || !variantIds.length) return;
    var vidKey = '__vids__' + variantIds.join(',');
    if (_ejRemovedKeys.has(vidKey)) return;
    _ejRemovedKeys.add(vidKey);

    /* Capture line-item-keys from DOM for these variant IDs */
    var cd = document.getElementById('CartDrawer');
    if (cd) {
      variantIds.forEach(function (vid) {
        cd.querySelectorAll('li[data-line-item-key]').forEach(function (li) {
          var liVid = li.querySelector('[data-quantity-variant-id]');
          if (liVid && liVid.getAttribute('data-quantity-variant-id') === String(vid)) {
            _ejRemovedLineKeys.add(li.getAttribute('data-line-item-key'));
          }
        });
      });
    }

    _ejRemovalQueue.push({ variantIds: variantIds });
    window._ejRemovalsInFlight = _ejRemovalQueue.length;
    ejEnsureRemovalsDonePromise();
    ejProcessRemovalQueue();
  }

  function ejProcessRemovalQueue() {
    if (_ejRemovalProcessing || _ejRemovalQueue.length === 0) return;
    _ejRemovalProcessing = true;

    var gkBtn = document.querySelector('.gokwik-checkout button');
    if (gkBtn) { gkBtn.disabled = true; gkBtn.classList.add('disabled'); }

    var request = _ejRemovalQueue.shift();

    var postPromise;
    if (request.key) {
      postPromise = fetch(getCartChangeJsUrl(), fetchConfig('POST', {
        body: JSON.stringify({ id: request.key, quantity: 0 })
      })).then(function (r) { return r.json(); });
    } else if (request.variantIds) {
      var updates = {};
      request.variantIds.forEach(function (vid) { updates[String(vid)] = 0; });
      postPromise = fetch(getCartUpdateJsUrl(), fetchConfig('POST', {
        body: JSON.stringify({ updates: updates })
      })).then(function (r) { return r.json(); });
    } else if (request.lineNum) {
      postPromise = fetch(getCartChangeJsUrl(), fetchConfig('POST', {
        body: JSON.stringify({ line: request.lineNum, quantity: 0 })
      })).then(function (r) { return r.json(); });
    } else {
      postPromise = Promise.resolve(null);
    }

    postPromise
      .then(function (cart) {
        if (cart) {
          normalizeAddResponse(cart);
          applyFooterAndBadgeFromCartJson(cart);
        }
        _ejRemovalProcessing = false;
        window._ejRemovalsInFlight = _ejRemovalQueue.length;

        if (_ejRemovalQueue.length > 0) {
          ejProcessRemovalQueue();
        } else {
          ejOnAllRemovalsDone(cart);
        }
      })
      .catch(function (err) {
        console.error('Cart removal error:', err);
        _ejRemovalProcessing = false;
        window._ejRemovalsInFlight = _ejRemovalQueue.length;

        if (_ejRemovalQueue.length > 0) {
          ejProcessRemovalQueue();
        } else {
          ejOnAllRemovalsDone(null);
        }
      });
  }

  function ejOnAllRemovalsDone(lastCart) {
    window._ejRemovalsInFlight = 0;
    /* _ejRemovedKeys and _ejRemovedLineKeys are NOT cleared here —
       they persist until silentSectionRefresh's onDone fires, so that
       any concurrent DOM-writing code path can strip zombie items. */
    ejResolveRemovalsDone();

    var cd = document.getElementById('CartDrawer');

    /* Remove any still-hidden items from DOM */
    if (cd) {
      cd.querySelectorAll('li[data-ej-removing="1"]').forEach(function (li) {
        li.remove();
      });
    }

    /* Update badge from server state */
    if (lastCart && typeof lastCart.item_count === 'number') {
      document.querySelectorAll('.header-eyejack__cart-badge').forEach(function (b) {
        b.textContent = String(lastCart.item_count);
        b.style.display = lastCart.item_count > 0 ? '' : 'none';
      });
    }

    syncCartDrawerEmptyUi(cd);
    syncOfferCardsWithDrawerDom();
    if (lastCart) dispatchCartRefreshAndUpdated(lastCart);

    var gkBtn = document.querySelector('.gokwik-checkout button');
    if (gkBtn) { gkBtn.disabled = false; gkBtn.classList.remove('disabled'); }

    /* Single sync with server — fetch fresh section HTML.
       All removals are confirmed, so server HTML is the truth.
       Clear removal tracking Sets only AFTER sync is done. */
    clearTimeout(window._ejSafetyNetTimer);
    window._ejSafetyNetTimer = setTimeout(function () {
      if (window._ejRemovalsInFlight || window._ejAddInFlight || window._ejQtyChangeInFlight) return;
      silentSectionRefresh({
        onDone: function (didUpdate) {
          _ejRemovedKeys.clear();
          _ejRemovedLineKeys.clear();
        }
      });
    }, 50);

    /* Late reconciliation for the free-gift offer. The free line items on this store are
       added & removed SERVER-SIDE by the offer app, and that adjustment can land a few hundred
       ms AFTER our /cart/change — i.e. after the 50ms sync above. Without a second sync the
       drawer keeps showing a stale "phantom" line (or a wrong count) once the app finishes
       adjusting the linked free items. silentSectionRefresh is idempotent and diff-based, so
       this extra fetch only repaints if the real cart actually changed. */
    clearTimeout(window._ejLateReconcileTimer);
    window._ejLateReconcileTimer = setTimeout(function () {
      if (window._ejRemovalsInFlight || window._ejAddInFlight || window._ejQtyChangeInFlight) return;
      silentSectionRefresh();
    }, 1400);
  }

  /* ── Legacy API wrappers: map old callers to the new queue ── */

  window._ejRemoveSingleLineByKey = function (lineItemKey) {
    ejQueueRemoval(lineItemKey);
  };

  window._ejBatchRemoval = function (variantIds) {
    ejQueueBatchRemovalByVids(variantIds);
  };

  window._ejBatchRemovalFallbackLine = function (lineNum) {
    /* Convert line number to line item key via DOM lookup, then queue */
    var cd = document.getElementById('CartDrawer');
    if (cd) {
      var inp = cd.querySelector('input[name="updates[]"][data-index="' + lineNum + '"]');
      var li = inp && inp.closest('li');
      var key = li ? li.getAttribute('data-line-item-key') : null;
      if (key) { ejQueueRemoval(key); return; }
    }
    /* Fallback: use variant ID if available */
    var vid = getVariantIdForLine(cd, lineNum);
    if (vid) { ejQueueBatchRemovalByVids([vid]); return; }
    /* Last resort: direct POST by line number (rare) */
    _ejRemovalQueue.push({ lineNum: lineNum });
    window._ejRemovalsInFlight = _ejRemovalQueue.length;
    ejEnsureRemovalsDonePromise();
    ejProcessRemovalQueue();
  };

  window._ejBatchRemovalWithPairLookup = function (variantIds, primaryVid) {
    /* First queue the known variant IDs for removal */
    variantIds.forEach(function (vid) { if (vid) _ejRemovedKeys.add('__vid__' + vid); });

    /* Look up paired items (lens+frame) from cart JSON, then queue everything */
    fetch(getCartJsUrl(), { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items || !primaryVid) return;
        var items = cart.items;
        var lineNum = -1;
        for (var i = 0; i < items.length; i++) {
          if (String(items[i].variant_id) === String(primaryVid) || String(items[i].id) === String(primaryVid)) {
            lineNum = i + 1; break;
          }
        }
        if (lineNum < 1) return;
        var victim = items[lineNum - 1];
        var allVids = variantIds.slice();
        if (isLensAdvizorLineItem(victim)) {
          var props = victim.properties || {};
          var frameRef = cartPropertyString(props['Associated Frame']) || cartPropertyString(props['Frame SKU']);
          if (frameRef) {
            var frameLine = findFrameLineByRef(items, frameRef, lineNum);
            if (frameLine && frameLine !== lineNum && items[frameLine - 1]) {
              allVids.push(String(items[frameLine - 1].variant_id));
            }
          }
        } else {
          var lensLines = findLensLinesForFrame(items, lineNum, victim);
          lensLines.forEach(function (ln) {
            if (items[ln - 1]) allVids.push(String(items[ln - 1].variant_id));
          });
        }
        ejQueueBatchRemovalByVids(allVids);
      })
      .catch(function () {
        ejQueueBatchRemovalByVids(variantIds);
      });
  };

  if (!customElements.get('cart-drawer-items')) {
    customElements.define(
      'cart-drawer-items',
      class extends CartItems {
        getSectionsToRender() {
          return [{ id: 'CartDrawer', section: 'cart-drawer', selector: '#CartDrawer' }];
        }
      }
    );
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define(
      'cart-drawer',
      class extends HTMLElement {
        constructor() {
          super();
          this._boundClose = this.close.bind(this);
          this._suppressEmptyCartAutoOpenUntil = 0;
          this._onKeyupEscape = function (evt) {
            if (evt.code === 'Escape') this.close();
          }.bind(this);
          this.addEventListener('keyup', this._onKeyupEscape);
        }

        connectedCallback() {
          var overlay = this.querySelector('#CartDrawer-Overlay');
          if (overlay) overlay.addEventListener('click', this._boundClose);
          this.setHeaderCartIconAccessibility();
          this._boundDocumentClick = this._handleDocumentCartIconClick.bind(this);
          document.addEventListener('click', this._boundDocumentClick, true);
        }

        disconnectedCallback() {
          document.removeEventListener('click', this._boundDocumentClick, true);
          this.removeEventListener('keyup', this._onKeyupEscape);
          var overlay = this.querySelector('#CartDrawer-Overlay');
          if (overlay) overlay.removeEventListener('click', this._boundClose);
        }

        _handleDocumentCartIconClick(event) {
          var target = event.target.closest(
            '#cart-icon-bubble, #cart-icon-bubble-mobile, #cart-icon-bubble-info'
          );
          if (target) {
            event.preventDefault();
            event.stopPropagation();
            this.open(target);
          }
        }

        setHeaderCartIconAccessibility() {
          var self = this;
          ['#cart-icon-bubble', '#cart-icon-bubble-mobile', '#cart-icon-bubble-info'].forEach(function (sel) {
            var link = document.querySelector(sel);
            if (!link) return;
            link.setAttribute('role', 'button');
            link.setAttribute('aria-haspopup', 'dialog');
            link.addEventListener('click', function (event) {
              event.preventDefault();
              self.open(link);
            });
            link.addEventListener('keydown', function (event) {
              if (event.code.toUpperCase() === 'SPACE') {
                event.preventDefault();
                self.open(link);
              }
            });
          });
        }

        open(triggeredBy) {
          this._suppressAutoOpenForEmptyCart = false;
          this._suppressEmptyCartAutoOpenUntil = 0;
          if (triggeredBy) this.activeElement = triggeredBy;
          var self = this;
          setTimeout(function () {
            self.classList.add('animate', 'active');
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                refreshCartDrawerRecommendedSwiperLayout();
              });
            });
          });
          this.addEventListener(
            'transitionend',
            function () {
              var wrap = document.getElementById('CartDrawer');
              var focusEl = self.querySelector('.drawer__inner');
              if (wrap && focusEl) trapFocus(wrap, focusEl);
            },
            { once: true }
          );
          document.body.classList.add('overflow-hidden');
        }

        close() {
          /* Stale /cart/change or section fetch may call renderContents after close(); do not reopen empty cart. */
          this._suppressAutoOpenForEmptyCart = true;
          var extendUntil = Date.now() + 5000;
          this._suppressEmptyCartAutoOpenUntil = Math.max(
            extendUntil,
            typeof this._suppressEmptyCartAutoOpenUntil === 'number' ? this._suppressEmptyCartAutoOpenUntil : 0
          );
          this.classList.remove('active', 'animate');
          removeTrapFocus(document.getElementById('CartDrawer'));
          document.body.classList.remove('overflow-hidden');
          if (this.activeElement && this.activeElement.focus) this.activeElement.focus();
        }

        renderContents(parsedState, options) {
          if (!parsedState) return;
          var opts = options || {};

          /* While an add-to-cart is in flight, block stale renders (from
             prior removal, error recovery, section fetches) that would
             wipe out optimistic content. Only the add-to-cart handler
             itself passes forceOpen or _fromAddHandler. */
          if (window._ejAddInFlight && !opts.forceOpen && !opts._fromAddHandler) {
            return;
          }
          if (window._ejRemovalsInFlight && !opts._fromRemovalSettle) {
            return;
          }

          var inner = this.querySelector('.drawer__inner');
          if (inner && inner.classList.contains('is-empty')) inner.classList.remove('is-empty');

          var self = this;
          var html = parsedState.sections && parsedState.sections['cart-drawer'];
          
          function postUpdateTasks() {
            if (typeof window.enableGokwikCart === 'function') {
              setTimeout(window.enableGokwikCart, 0);
            }
            var overlay = self.querySelector('#CartDrawer-Overlay');
            if (overlay && overlay.parentNode) {
              var clone = overlay.cloneNode(true);
              overlay.parentNode.replaceChild(clone, overlay);
              clone.addEventListener('click', self._boundClose);
            }
          }
          
          if (html) {
            var el = document.querySelector('#CartDrawer');
            if (el) {
              try {
                var oldFill = el.querySelector('[data-tier-unified-fill]');
                var prevTierFillScale = oldFill ? getTierUnifiedFillScale(oldFill) : null;
                if (prevTierFillScale == null && typeof lastTierUnifiedFillScale === 'number') {
                  prevTierFillScale = lastTierUnifiedFillScale;
                }
                
                var isAlreadyOpen = this.classList.contains('active');
                
                if (isAlreadyOpen) {
                  /* ── SURGICAL UPDATE: only swap parts that change ── */
                  var newDoc = new DOMParser().parseFromString(html, 'text/html');
                  var newCartRoot = newDoc.querySelector('#CartDrawer');
                  if (!newCartRoot) {
                    newCartRoot = newDoc.querySelector('.cart-drawer');
                  }
                  
                  var didSurgical = false;
                  
                  if (newCartRoot) {
                    /* Strip removed items from server HTML before applying */
                    if (_ejRemovedLineKeys.size > 0) {
                      _ejRemovedLineKeys.forEach(function (rk) {
                        var zombie = newCartRoot.querySelector('li[data-line-item-key="' + rk + '"]');
                        if (zombie) zombie.remove();
                      });
                    }

                    /* 1. Swap BOGO offer card */
                    var oldBogo = el.querySelector('.cart-drawer__offer-slot--b1g1');
                    var newBogo = newCartRoot.querySelector('.cart-drawer__offer-slot--b1g1');
                    if (oldBogo && newBogo) {
                      oldBogo.innerHTML = newBogo.innerHTML;
                    } else if (!oldBogo && newBogo) {
                      var itemsContainer = el.querySelector('cart-drawer-items');
                      if (itemsContainer) itemsContainer.insertBefore(newBogo, itemsContainer.firstChild);
                    } else if (oldBogo && !newBogo) {
                      oldBogo.remove();
                    }
                    
                    /* 2. Replace cart items list (full innerHTML, not reconcile) */
                    var oldList = el.querySelector('.sidebar-cart-list');
                    var newList = newCartRoot.querySelector('.sidebar-cart-list');
                    if (oldList && newList) {
                      /* Remove hidden items from current DOM */
                      oldList.querySelectorAll('li[data-ej-removing="1"]').forEach(function (li) { li.remove(); });
                      oldList.innerHTML = newList.innerHTML;
                      didSurgical = true;
                    }

                    /* 3. Swap footer — surgical: only totals + buttons */
                    var oldFooter = el.querySelector('.dz-drawer-footer');
                    var newFooter = newCartRoot.querySelector('.dz-drawer-footer');
                    if (oldFooter && newFooter) {
                      var oSummary = oldFooter.querySelector('.cart-drawer__order-summary');
                      var nSummary = newFooter.querySelector('.cart-drawer__order-summary');
                      if (oSummary && nSummary && oSummary.innerHTML !== nSummary.innerHTML) oSummary.innerHTML = nSummary.innerHTML;
                      var oCbtns = oldFooter.querySelector('.dz-cart-btns');
                      var nCbtns = newFooter.querySelector('.dz-cart-btns');
                      if (oCbtns && nCbtns && oCbtns.innerHTML !== nCbtns.innerHTML) oCbtns.innerHTML = nCbtns.innerHTML;
                      else if (!oCbtns && nCbtns) { var fStack2 = oldFooter.querySelector('.cart-drawer__footer-summary-stack'); if (fStack2) fStack2.appendChild(nCbtns.cloneNode(true)); }
                    } else if (!oldFooter && newFooter) {
                      var drawerInner = el.querySelector('.drawer__inner');
                      if (drawerInner) drawerInner.appendChild(newFooter);
                    } else if (oldFooter && !newFooter) {
                      oldFooter.remove();
                    }

                    /* 4. Swap empty state visibility */
                    var oldEmpty = el.querySelector('.drawer-empty');
                    var newEmpty = newCartRoot.querySelector('.drawer-empty');
                    if (oldEmpty && newEmpty) {
                      oldEmpty.hidden = newEmpty.hidden;
                    }
                  }
                  
                  if (!didSurgical) {
                    /* Fallback: full replace if surgical targets not found */
                    el.classList.remove('cart-drawer--empty');
                    el.innerHTML = getSectionInnerHTML(html, '#CartDrawer');
                  } else {
                    el.classList.remove('cart-drawer--empty');
                  }

                  /* Post-replace: strip zombies from live DOM */
                  if (_ejRemovedLineKeys.size > 0) {
                    _ejRemovedLineKeys.forEach(function (rk) {
                      var z = el.querySelector('li[data-line-item-key="' + rk + '"]');
                      if (z) z.remove();
                    });
                  }
                  
                  syncCartDrawerEmptyUi(el);
                  animateTierUnifiedFillAfterSectionSwap(prevTierFillScale);
                  postUpdateTasks();
                } else {
                  /* ── FULL REPLACE: cart is closed, no flash visible ── */
                  el.classList.remove('cart-drawer--empty');
                  el.innerHTML = getSectionInnerHTML(html, '#CartDrawer');

                  /* Strip zombies after full replace */
                  if (_ejRemovedLineKeys.size > 0) {
                    _ejRemovedLineKeys.forEach(function (rk) {
                      var z = el.querySelector('li[data-line-item-key="' + rk + '"]');
                      if (z) z.remove();
                    });
                  }

                  syncCartDrawerEmptyUi(el);
                  animateTierUnifiedFillAfterSectionSwap(prevTierFillScale);
                  postUpdateTasks();
                }
              } catch (e) {
                console.warn('Cart drawer update', e);
                postUpdateTasks();
              }
            }
          } else {
            postUpdateTasks();
          }

          if (typeof parsedState.item_count === 'number') {
            document.querySelectorAll('.header-eyejack__cart-badge').forEach(function (badge) {
              badge.textContent = parsedState.item_count;
              badge.style.display = parsedState.item_count > 0 ? '' : 'none';
            });
          }

          if (!this.classList.contains('active')) {
            var cartRoot = document.querySelector('#CartDrawer');
            var ic =
              parsedState && typeof parsedState.item_count === 'number' ? parsedState.item_count : null;
            var looksEmpty =
              ic === 0 ||
              (ic == null &&
                cartRoot &&
                (cartRoot.classList.contains('cart-drawer--empty') || cartDrawerHasNoLineItems(cartRoot)));
            var withinWindow =
              typeof this._suppressEmptyCartAutoOpenUntil === 'number' &&
              this._suppressEmptyCartAutoOpenUntil > Date.now();
            var skipAutoOpen =
              !opts.forceOpen &&
              looksEmpty &&
              (this._suppressAutoOpenForEmptyCart || withinWindow);
            if (!skipAutoOpen) {
              this.open();
            }
          }
          
          syncOrderSummaryFromCartFetch(parsedState);
        }
      }
    );
  }

  if (window.__ejPendingCartAdd) {
    window.__ejDispatchPendingCartAdd();
  }

  /* ---------- Offer card ---------- */
  function getCartItemRows(container) {
    var list = (container || document).querySelector('.sidebar-cart-list');
    if (!list) return [];
    return Array.prototype.slice.call(list.querySelectorAll('li[data-item-quantity]'));
  }

  function getDisplayCount(container) {
    return getCartItemRows(container).reduce(function (sum, row) {
      if (row.getAttribute('data-is-excluded') === 'true') return sum;
      var qty = parseInt(row.getAttribute('data-item-quantity') || '0', 10);
      return sum + (isNaN(qty) ? 0 : qty);
    }, 0);
  }

  function tierOfferSegmentedProgressPercent(subCents, t1, t2, t3) {
    if (subCents >= t3) return 100;
    if (t1 <= 0) return 0;
    if (subCents < t1) {
      return 0;
    }
    if (subCents < t2) {
      var segD = t2 - t1;
      if (segD <= 0) return 33;
      var seg = subCents - t1;
      var segPct = Math.floor((seg * 100) / segD);
      return 33 + Math.floor((segPct * 100) / 300);
    }
    if (subCents < t3) {
      var segD = t3 - t2;
      if (segD <= 0) return 66;
      var seg = subCents - t2;
      var segPct = Math.floor((seg * 100) / segD);
      return 66 + Math.floor((segPct * 100) / 300);
    }
    return 100;
  }

  function formatTierMoneyCents(cents) {
    var n = Math.max(0, Math.round(cents));
    var r = (n / 100).toLocaleString('en-IN', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
    return '₹' + r;
  }

  function computeTierSubtotalFromRows(scope) {
    var list = scope && scope.querySelector ? scope.querySelector('.sidebar-cart-list') : null;
    if (!list) {
      return { subtotal: 0, hasQualifying: false };
    }
    var rows = list.querySelectorAll('li[data-item-quantity]');
    var subtotal = 0;
    var hasQualifying = false;
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var price = parseInt(row.getAttribute('data-item-price') || '0', 10);
      var qty = parseInt(row.getAttribute('data-item-quantity') || '0', 10);
      var origLine = parseInt(row.getAttribute('data-original-line-total') || '0', 10);
      var lineTotal = parseInt(row.getAttribute('data-item-line-total') || '0', 10);
      if (row.getAttribute('data-is-excluded') === 'true') continue;
      hasQualifying = true;
      if (origLine > 0) subtotal += origLine;
      else if (lineTotal > 0) subtotal += lineTotal;
      else subtotal += price * (isNaN(qty) ? 0 : qty);
    }
    return { subtotal: subtotal, hasQualifying: hasQualifying };
  }

  /** Match Liquid segment fill: three stretches 0→t1, t1→t2, t2→t3 (fractional % for smoother motion). */
  function tierSegPct(numer, denom) {
    if (denom <= 0) return 100;
    var v = (numer * 100) / denom;
    return Math.min(100, Math.round(v * 100) / 100);
  }

  function tierSegmentFills(sub, t1, t2, t3) {
    var s1 = 0;
    var s2 = 0;
    var s3 = 0;
    if (sub >= t3) return { s1: 100, s2: 100, s3: 100 };
    if (sub >= t2) {
      s1 = 100;
      s2 = 100;
      var d = t3 - t2;
      s3 = d > 0 ? tierSegPct(sub - t2, d) : 100;
      return { s1: s1, s2: s2, s3: s3 };
    }
    if (sub >= t1) {
      s1 = 100;
      var d2 = t2 - t1;
      s2 = d2 > 0 ? tierSegPct(sub - t1, d2) : 100;
      return { s1: s1, s2: s2, s3: 0 };
    }
    return { s1: 0, s2: 0, s3: 0 };
  }

  /** Luna rail: align track ends to first/last node centers (works with space-between milestone columns). */
  function syncLunaTierTrackExtents(scope) {
    var root = scope && scope.querySelector ? scope : document.getElementById('CartDrawer') || document;
    var wrap = root.querySelector('.offer-tier-card__rail--luna .offer-tier-card__track-nodes-wrap');
    if (!wrap) return;
    var n1 = wrap.querySelector('[data-tier-node="1"]');
    var n3 = wrap.querySelector('[data-tier-node="3"]');
    if (!n1 || !n3) return;
    var wrapRect = wrap.getBoundingClientRect();
    if (wrapRect.width < 2) return;
    var n1Rect = n1.getBoundingClientRect();
    var n3Rect = n3.getBoundingClientRect();
    var c1 = n1Rect.left + n1Rect.width / 2;
    var c3 = n3Rect.left + n3Rect.width / 2;
    var left = c1 - wrapRect.left;
    var right = wrapRect.right - c3;
    if (left < 0 || right < 0) return;
    wrap.style.setProperty('--tier-track-left', left + 'px');
    wrap.style.setProperty('--tier-track-right', right + 'px');
  }

  function setupLunaTierTrackResizeObserver(scope) {
    var root = scope && scope.querySelector ? scope : document.getElementById('CartDrawer') || document;
    var wrap = root.querySelector('.offer-tier-card__rail--luna .offer-tier-card__track-nodes-wrap');
    if (!wrap || wrap._lunaTrackResizeObs) return;
    if (typeof ResizeObserver === 'undefined') return;
    wrap._lunaTrackResizeObs = new ResizeObserver(function () {
      var cartRoot = document.getElementById('CartDrawer') || document;
      if (wrap._lunaResizeSyncRaf) cancelAnimationFrame(wrap._lunaResizeSyncRaf);
      wrap._lunaResizeSyncRaf = requestAnimationFrame(function () {
        wrap._lunaResizeSyncRaf = null;
        syncLunaTierTrackExtents(cartRoot);
      });
    });
    wrap._lunaTrackResizeObs.observe(wrap);
  }

  /** Recommended carousel heading/sub (default copy) — same next-tier ₹ as mint banner + progress card. */
  function updateRecommendedTierDynamicCopy(scope, sub, t1, t2, t3, d1, d2, d3) {
    var rec = scope.querySelector('[data-cart-drawer-recommended]');
    if (!rec) return;
    var titleEl = rec.querySelector('[data-tier-rec-dynamic="title"]');
    var subEl = rec.querySelector('[data-tier-rec-dynamic="sub"]');
    if (!titleEl && !subEl) return;
    var nd = d1;
    if (sub < t1) nd = d1;
    else if (sub < t2) nd = d2;
    else if (sub < t3) nd = d3;
    var disc = sub >= t3 ? d3 : nd;
    if (titleEl) titleEl.textContent = 'Unlock ₹' + disc + ' savings';
    if (subEl) subEl.textContent = 'Add any item below & unlock ₹' + disc + ' OFF';
  }

  function updateTierOfferCardUI(container) {
    var scope = offerCardScope(container);
    var tierCard = scope.querySelector('.offer-tier-card[data-offer="tier-spend"]');
    if (!tierCard) return;

    var slot = scope.querySelector('.cart-drawer__offer-slot');
    var mintBanner = scope.querySelector('[data-tier-mint-banner]');
    var t1 = parseInt(tierCard.getAttribute('data-t1') || '0', 10);
    var t2 = parseInt(tierCard.getAttribute('data-t2') || '0', 10);
    var t3 = parseInt(tierCard.getAttribute('data-t3') || '0', 10);
    var d1 = parseInt(tierCard.getAttribute('data-d1') || '0', 10);
    var d2 = parseInt(tierCard.getAttribute('data-d2') || '0', 10);
    var d3 = parseInt(tierCard.getAttribute('data-d3') || '0', 10);

    var computed = computeTierSubtotalFromRows(scope);
    var sub = computed.subtotal;

    if (!computed.hasQualifying) {
      if (slot) slot.hidden = true;
      if (mintBanner) mintBanner.hidden = true;
      updateRecommendedTierDynamicCopy(scope, 0, t1, t2, t3, d1, d2, d3);
      return;
    }
    if (slot) slot.hidden = false;
    if (mintBanner) mintBanner.hidden = false;

    var tier1Unlocked = sub >= t1;
    var tier2Unlocked = sub >= t2;
    var tier3Unlocked = sub >= t3;

    var tierOuter = tierCard.closest('.cart-offer-card--tier');
    var tr1 = tierOuter ? parseInt(tierOuter.getAttribute('data-tr1-rupees') || '0', 10) : 0;
    var tr2 = tierOuter ? parseInt(tierOuter.getAttribute('data-tr2-rupees') || '0', 10) : 0;
    var tr3 = tierOuter ? parseInt(tierOuter.getAttribute('data-tr3-rupees') || '0', 10) : 0;

    var gapCents = 0;
    var nextDiscount = d1;
    if (sub < t1) {
      gapCents = t1 - sub;
      nextDiscount = d1;
    } else if (sub < t2) {
      gapCents = t2 - sub;
      nextDiscount = d2;
    } else if (sub < t3) {
      gapCents = t3 - sub;
      nextDiscount = d3;
    }

    var mintCopy = mintBanner ? mintBanner.querySelector('[data-tier-mint-copy]') : null;
    if (mintCopy) {
      if (sub >= t3) {
        mintCopy.textContent = "🥳 You've unlocked all tier rewards! 🥳";
      } else {
        var mintLead = '👉 🛒 ';
        var mintTrail = ' 🎉';
        if (sub >= t1 && sub < t2) {
          mintLead = '👉 🚀 ';
          mintTrail = ' ⭐';
        } else if (sub >= t2 && sub < t3) {
          mintLead = '👉 🔥 ';
          mintTrail = ' 💸';
        }
        mintCopy.innerHTML =
          mintLead +
          'Add <span class="tier-mint-banner__em">' +
          formatTierMoneyCents(gapCents) +
          '</span> more & SAVE <span class="tier-mint-banner__em">₹' +
          nextDiscount +
          '</span> instantly' +
          mintTrail;
      }
    }
    if (mintBanner) {
      if (sub >= t3) {
        mintBanner.classList.remove('cart-drawer__tier-mint-banner--flash');
      } else {
        mintBanner.classList.add('cart-drawer__tier-mint-banner--flash');
      }
    }

    function setNode(n, unlocked) {
      var node = tierCard.querySelector('[data-tier-node="' + n + '"]');
      if (node) {
        if (unlocked) node.classList.add('offer-tier-card__node--done');
        else node.classList.remove('offer-tier-card__node--done');
      }
      var label = tierCard.querySelector('[data-tier-label="' + n + '"]');
      if (label) {
        if (unlocked) label.classList.add('offer-tier-card__label--unlocked');
        else label.classList.remove('offer-tier-card__label--unlocked');
      }
    }
    setNode(1, tier1Unlocked);
    setNode(2, tier2Unlocked);
    setNode(3, tier3Unlocked);

    tierCard.querySelectorAll('[data-tier-node]').forEach(function (nodeEl) {
      nodeEl.classList.remove('offer-tier-card__node--current');
    });
    if (sub < t1) {
      var n1 = tierCard.querySelector('[data-tier-node="1"]');
      if (n1) n1.classList.add('offer-tier-card__node--current');
    } else if (sub < t2) {
      var n2 = tierCard.querySelector('[data-tier-node="2"]');
      if (n2) n2.classList.add('offer-tier-card__node--current');
    } else if (sub < t3) {
      var n3 = tierCard.querySelector('[data-tier-node="3"]');
      if (n3) n3.classList.add('offer-tier-card__node--current');
    }

    var gapSub1 = tierCard.querySelector('[data-tier-gap-sub="1"]');
    var gapSub2 = tierCard.querySelector('[data-tier-gap-sub="2"]');
    var gapSub3 = tierCard.querySelector('[data-tier-gap-sub="3"]');
    var addGap = 'ADD ' + formatTierMoneyCents(gapCents) + ' MORE';
    if (gapSub1) {
      gapSub1.hidden = sub >= t1;
      gapSub1.textContent = addGap;
    }
    if (gapSub2) {
      gapSub2.hidden = sub < t1 || sub >= t2;
      gapSub2.textContent = addGap;
    }
    if (gapSub3) {
      gapSub3.hidden = sub < t2 || sub >= t3;
      gapSub3.textContent = addGap;
    }

    tierCard.querySelectorAll('[data-tier-label-col]').forEach(function (col) {
      col.classList.remove('offer-tier-card__label-col--current');
    });
    var nextCol = sub < t1 ? 1 : sub < t2 ? 2 : sub < t3 ? 3 : 0;
    if (nextCol) {
      var nextColEl = tierCard.querySelector('[data-tier-label-col="' + nextCol + '"]');
      if (nextColEl) nextColEl.classList.add('offer-tier-card__label-col--current');
    }

    tierCard.setAttribute('data-tier-subtotal', String(sub));
    if (tierOuter) tierOuter.setAttribute('data-tier-subtotal', String(sub));

    /* Luna: defer sync + fills to next frame so flex layout from milestone/gap updates is stable
       before getBoundingClientRect and before applying transform targets (smoother linear motion). */
    if (tierCard.classList.contains('offer-tier-card--luna')) {
      setupLunaTierTrackResizeObserver(scope);
      var subL = sub;
      var t1L = t1;
      var t2L = t2;
      var t3L = t3;
      requestAnimationFrame(function () {
        syncLunaTierTrackExtents(scope);
        var segsL = tierSegmentFills(subL, t1L, t2L, t3L);
        var unifiedL = tierUnifiedFillPercent(segsL.s1, segsL.s2, segsL.s3);
        var fillL = tierCard.querySelector('[data-tier-unified-fill]');
        if (fillL) setLunaSegmentFillScale(fillL, unifiedL);
      });
    } else {
      var segs = tierSegmentFills(sub, t1, t2, t3);
      var unified = tierUnifiedFillPercent(segs.s1, segs.s2, segs.s3);
      var fillEl = tierCard.querySelector('[data-tier-unified-fill]');
      if (fillEl) setLunaSegmentFillScale(fillEl, unified);
    }

    updateRecommendedTierDynamicCopy(scope, sub, t1, t2, t3, d1, d2, d3);
  }

  function updateOfferCardUI(container) {
    var root = container || document;
    var card = root.querySelector('.offer-card[data-offer="dynamic"]');
    if (!card) return;

    var count = parseInt(card.getAttribute('data-current') || '0', 10);
    var required = parseInt(card.getAttribute('data-required') || '2', 10);
    var isCOD = card.getAttribute('data-offer-type') === 'cod';

    if (isCOD && root.querySelector('.sidebar-cart-list')) {
      var rows = root.querySelectorAll('.sidebar-cart-list li[data-item-price][data-item-quantity]');
      var codCount = 0;
      rows.forEach(function (row) {
        if (row.getAttribute('data-is-excluded') === 'true') return;
        var price = parseInt(row.getAttribute('data-item-price') || '0', 10);
        var qty = parseInt(row.getAttribute('data-item-quantity') || '0', 10);
        if (price === 39900) codCount += qty;
      });
      if (rows.length > 0) count = codCount;
    } else if (isNaN(count) || isNaN(required)) {
      count = getDisplayCount(container);
      required = 2;
    }

    var progressPercent = required > 0 ? Math.min(100, Math.round((count * 100) / required)) : 0;
    if (required >= 2 && count === 1) progressPercent = 50;
    var isUnlocked = count >= required;

    var fill = card.querySelector('.offer-card__progress-fill--orange, .offer-card__progress-fill--purple');
    if (fill) fill.style.width = progressPercent + '%';

    var countEl = card.querySelector('.offer-card__progress-count');
    if (countEl) countEl.textContent = count + '/' + required + ' Items';

    var badge = card.querySelector('.offer-card__badge--orange, .offer-card__badge--purple');
    if (badge) {
      badge.textContent = isCOD ? (isUnlocked ? 'UNLOCKED' : '1 LEFT') : isUnlocked ? 'UNLOCKED' : 'HOT';
    }

    var statusEl = card.querySelector('.offer-card__progress-percent--orange, .offer-card__progress-percent--purple');
    if (statusEl) {
      statusEl.textContent = isCOD
        ? isUnlocked
          ? 'COD Unlocked'
          : 'COD Active'
        : isUnlocked
          ? 'Deal Active'
          : 'Unlock deal';
    }

    var subtitle = card.querySelector('.offer-card__subtitle');
    if (subtitle) {
      if (isCOD) {
        subtitle.textContent = isUnlocked ? 'You have unlocked COD' : 'Add 1 more for COD';
      } else {
        var subtitleUnlocked = card.getAttribute('data-subtitle-unlocked') || 'Great savings deal!';
        subtitle.textContent = isUnlocked ? subtitleUnlocked : 'Great savings deal';
      }
    }

    var titleEl = card.querySelector('.offer-card__title');
    if (titleEl) {
      if (isCOD) {
        titleEl.textContent = isUnlocked ? 'COD Unlocked' : 'Unlock COD';
      } else {
        var titleUnlocked = card.getAttribute('data-title-unlocked') || 'Offer Applied';
        titleEl.textContent = isUnlocked
          ? titleUnlocked
          : card.getAttribute('data-offer-line') || titleEl.textContent;
      }
    }

    var savingsEl = card.querySelector('.offer-card__savings');
    if (savingsEl && isCOD) {
      savingsEl.textContent = isUnlocked
        ? 'Cash on Delivery Unlocked'
        : 'Cash on Delivery Available';
    }

    var iconWrap = card.querySelector('.offer-card__icon');
    if (iconWrap && !isCOD) {
      if (isUnlocked) {
        if (!iconWrap.querySelector('.offer-card__icon-check')) {
          var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          svg.setAttribute('class', 'offer-card__icon-img offer-card__icon-check');
          svg.setAttribute('width', '24');
          svg.setAttribute('height', '24');
          svg.setAttribute('viewBox', '0 0 24 24');
          svg.setAttribute('fill', 'none');
          svg.setAttribute('aria-hidden', 'true');
          var circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
          circle.setAttribute('cx', '12');
          circle.setAttribute('cy', '12');
          circle.setAttribute('r', '10');
          circle.setAttribute('fill', '#22C55E');
          var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
          path.setAttribute('d', 'M8 12l3 3 5-6');
          path.setAttribute('stroke', 'white');
          path.setAttribute('stroke-width', '2');
          path.setAttribute('stroke-linecap', 'round');
          path.setAttribute('stroke-linejoin', 'round');
          svg.appendChild(circle);
          svg.appendChild(path);
          iconWrap.classList.add('offer-card__icon--unlocked');
          iconWrap.innerHTML = '';
          iconWrap.appendChild(svg);
        }
      } else if (!iconWrap.querySelector('img')) {
        var img = document.createElement('img');
        img.src =
          'https://cdn.shopify.com/s/files/1/0583/8831/6208/files/imgbin_e9211932f38071a1d5f250b6150a7acb.png?v=1772272856';
        img.alt = 'Deal';
        img.width = 24;
        img.height = 24;
        img.className = 'offer-card__icon-img';
        iconWrap.classList.remove('offer-card__icon--unlocked');
        iconWrap.innerHTML = '';
        iconWrap.appendChild(img);
      }
    }

    var badgeEl = card.querySelector('.offer-card__badge');
    if (badgeEl) {
      if (isUnlocked) badgeEl.classList.add('offer-card__badge--green');
      else badgeEl.classList.remove('offer-card__badge--green');
    }

    card.setAttribute('data-unlocked', isUnlocked ? 'true' : 'false');
    var track = card.querySelector('.offer-card__progress-track');
    if (track) {
      track.setAttribute('aria-valuenow', String(progressPercent));
      track.setAttribute('aria-label', count + ' of ' + required + ' items');
    }

    var outer = root.querySelector('.cart-offer-card');
    if (outer) outer.setAttribute('data-unlocked', isUnlocked ? 'true' : 'false');
  }

  /* ---- B1G1 (Buy 1 Get 1 Free) Offer Card ---- */
  function updateB1G1OfferCard(scope) {
    var card = scope.querySelector('[data-b1g1-card]');
    if (!card) return;

    var list = scope.querySelector('.sidebar-cart-list');
    var count = 0;
    if (list) {
      var rows = list.querySelectorAll('li[data-item-quantity]');
      for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        if (row.getAttribute('data-is-excluded') === 'true') continue;
        var qty = parseInt(row.getAttribute('data-item-quantity') || '0', 10);
        count += isNaN(qty) ? 0 : qty;
      }
    }

    var required = 2;
    card.setAttribute('data-required', String(required));

    var isApplied = count >= required;
    var remaining = Math.max(0, required - count);
    var displayCount = Math.min(count, required);

    card.setAttribute('data-b1g1-applied', isApplied ? 'true' : 'false');
    card.setAttribute('data-current', String(count));

    var titleEl = card.querySelector('[data-b1g1-title]');
    if (titleEl) {
      titleEl.textContent = isApplied ? 'Offer Applied!' : 'Buy 1 Get 1 Free!';
    }

    var subtitleEl = card.querySelector('[data-b1g1-subtitle]');
    if (subtitleEl) {
      if (isApplied) {
        subtitleEl.textContent = 'Free item unlocked';
      } else {
        subtitleEl.textContent = 'Add ' + remaining + ' more item' + (remaining > 1 ? 's' : '') + ' to unlock free item';
      }
    }

    var iconEl = card.querySelector('[data-b1g1-icon]');
    if (iconEl) {
      if (isApplied) {
        iconEl.innerHTML =
          '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" aria-hidden="true">' +
          '<circle cx="20" cy="20" r="20" fill="#16a34a"/>' +
          '<path d="M12 20l6 6 10-12" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>';
      } else {
        iconEl.innerHTML =
          '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" aria-hidden="true">' +
          '<circle cx="20" cy="20" r="20" fill="#111"/>' +
          '<path d="M26 17v8a1 1 0 01-1 1H15a1 1 0 01-1-1v-8" stroke="#fff" stroke-width="1.5" stroke-linecap="round"/>' +
          '<path d="M28 14H12v3h16v-3z" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
          '<path d="M20 26v-12" stroke="#fff" stroke-width="1.5"/>' +
          '<path d="M20 14s-1-3-3.5-3c-1.38 0-2.5 1.12-2.5 2.5s1.12 2.5 2.5 2.5" stroke="#fff" stroke-width="1.5" stroke-linecap="round"/>' +
          '<path d="M20 14s1-3 3.5-3c1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5" stroke="#fff" stroke-width="1.5" stroke-linecap="round"/>' +
          '</svg>';
      }
    }

    var badgeEl = card.querySelector('[data-b1g1-badge]');
    if (isApplied) {
      if (!badgeEl) {
        badgeEl = document.createElement('span');
        badgeEl.className = 'b1g1-offer-card__badge';
        badgeEl.setAttribute('data-b1g1-badge', '');
        badgeEl.textContent = 'APPLIED';
        var header = card.querySelector('.b1g1-offer-card__header');
        if (header) header.appendChild(badgeEl);
      }
      badgeEl.hidden = false;
    } else if (badgeEl) {
      badgeEl.hidden = true;
    }

    var fill = card.querySelector('[data-b1g1-fill]');
    if (fill) {
      var pct = required > 0 ? Math.min(100, Math.round((displayCount * 100) / required)) : 0;
      fill.style.width = pct + '%';
    }

    var countEl = card.querySelector('[data-b1g1-count]');
    if (countEl) {
      countEl.innerHTML = '<strong>' + displayCount + '</strong> of ' + required + ' items added';
    }

    var dotsWrap = card.querySelector('.b1g1-offer-card__dots');
    if (dotsWrap) {
      var dotsHtml = '';
      for (var d = 1; d <= required; d++) {
        var cls = 'b1g1-offer-card__dot';
        if (count >= d) {
          cls += ' b1g1-offer-card__dot--filled';
          if (d === required) cls += ' b1g1-offer-card__dot--applied';
        }
        dotsHtml += '<span class="' + cls + '" data-b1g1-dot="' + d + '">' + d + '</span>';
      }
      dotsWrap.innerHTML = dotsHtml;
    }

    var slot = card.closest('.cart-drawer__offer-slot');
    if (slot) {
      var hasItems = false;
      if (list) {
        var allRows = list.querySelectorAll('li[data-item-quantity]');
        for (var j = 0; j < allRows.length; j++) {
          if (allRows[j].getAttribute('data-is-excluded') !== 'true') {
            hasItems = true;
            break;
          }
        }
      }
      slot.hidden = !hasItems;
    }

    var rec = scope.querySelector('[data-cart-drawer-recommended]');
    if (rec) {
      var recTitle = rec.querySelector('.cart-drawer__recommended-title');
      var recSub = rec.querySelector('.cart-drawer__recommended-sub');
      if (recTitle) {
        recTitle.textContent = 'Still thinking about these?';
      }
      if (recSub) {
        recSub.textContent = 'Grab them now before they sell out';
      }
    }
  }

  function offerCardScope(container) {
    if (container && container.closest) {
      var inDrawer = container.closest('#CartDrawer');
      if (inDrawer) return inDrawer;
    }
    return document.getElementById('CartDrawer') || container || document;
  }

  function runOfferCard(container) {
    var scope = offerCardScope(container);
    if (scope.querySelector('[data-b1g1-card]')) {
      updateB1G1OfferCard(scope);
    }
    if (scope.querySelector('.offer-card[data-offer="dynamic"]')) {
      updateOfferCardUI(scope);
    }
    if (scope.querySelector('.offer-tier-card[data-offer="tier-spend"]')) {
      scheduleTierOfferCardUpdate(container);
    }
    updateB1G1FreeItemDisplay(scope);
  }

  /**
   * Update BOGO free item price display on cart line items.
   * Every 2 qualifying items = 1 free. Distributes free qty across items.
   */
  /**
   * Discount display is now handled entirely by server-rendered HTML.
   * This function is a no-op placeholder to maintain compatibility.
   * The server HTML contains the correct discount info from Shopify.
   */
  function updateB1G1FreeItemDisplay(scope) {
    /* No-op: Server HTML already contains correct discount display from Shopify */
  }

  window.cartOfferCardUpdate = runOfferCard;

  /** Skip work when recommended markup unchanged and Swiper already bound. */
  function maybeInitCartDrawerRecommendedSwiper() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    var el = drawer.querySelector('.cart-drawer__recommended-swiper');
    if (!el || el.getAttribute('data-swiper-inited') === '1') return;
    initCartDrawerRecommendedSwiper();
  }

  /** After drawer opens or viewport changes: init if needed and recalc slide widths (hidden drawer → width 0 at first init). */
  function refreshCartDrawerRecommendedSwiperLayout() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    var el = drawer.querySelector('.cart-drawer__recommended-swiper');
    if (!el) return;
    maybeInitCartDrawerRecommendedSwiper();
    var inst = el.swiper;
    if (inst && typeof inst.update === 'function') {
      inst.update();
    }
  }

  function initCartDrawerRecommendedSwiper() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    var el = drawer.querySelector('.cart-drawer__recommended-swiper');
    if (!el || el.getAttribute('data-swiper-inited') === '1') return;
    if (typeof Swiper === 'undefined') return;
    var slides = el.querySelectorAll('.swiper-slide');
    if (slides.length === 0) return;
    var wrap = el.closest('.cart-drawer__recommended');
    var prevBtn = wrap ? wrap.querySelector('[data-cart-rec-prev]') : null;
    var nextBtn = wrap ? wrap.querySelector('[data-cart-rec-next]') : null;
    el.setAttribute('data-swiper-inited', '1');
    try {
      new Swiper(el, {
        slidesPerView: 3,
        spaceBetween: 8,
        slidesPerGroup: 1,
        watchOverflow: true,
        nested: true,
        navigation:
          prevBtn && nextBtn
            ? {
                prevEl: prevBtn,
                nextEl: nextBtn,
              }
            : undefined,
        /* Must be false so vertical drags propagate to cart-drawer-items (scroll parent) */
        touchMoveStopPropagation: false,
        touchReleaseOnEdges: true,
        /* Do not call preventDefault on touchstart — allows the drawer body to scroll vertically */
        touchStartPreventDefault: false,
        resistanceRatio: 0.85,
      });
    } catch (e) {
      el.removeAttribute('data-swiper-inited');
      console.warn('cart-drawer recommended Swiper', e);
    }
  }

  var _ejCheckoutOrigLabel = '';
  var _ejCheckoutSafetyTimer = null;

  function ejSetCheckoutProcessing() {
    clearTimeout(_ejCheckoutSafetyTimer);
    var gkBtns = document.querySelectorAll('.gokwik-checkout button, [data-ej-optimistic-checkout]');
    gkBtns.forEach(function (b) {
      var lbl = b.querySelector('[data-ej-checkout-label]') || b.querySelector('.btn-text span') || b.querySelector('.btn-text');
      if (lbl) {
        if (!_ejCheckoutOrigLabel) _ejCheckoutOrigLabel = lbl.textContent;
        lbl.textContent = 'Processing\u2026';
      }
      var secureIcon = b.querySelector('.secure-icon');
      if (secureIcon) secureIcon.style.display = 'none';
      var arrowIcon = b.querySelector('.arrow-icon');
      if (arrowIcon) arrowIcon.style.display = 'none';
      b.style.opacity = '0.7';
      b.style.pointerEvents = 'none';
    });

    /* Failsafe: never let the button stay stuck for more than 8 seconds.
       If any code path forgets to restore, this guarantees recovery. */
    _ejCheckoutSafetyTimer = setTimeout(function () {
      ejRestoreCheckoutButton();
    }, 8000);
  }

  function ejRestoreCheckoutButton() {
    clearTimeout(_ejCheckoutSafetyTimer);
    var gkBtns = document.querySelectorAll('.gokwik-checkout button, [data-ej-optimistic-checkout]');
    gkBtns.forEach(function (b) {
      var lbl = b.querySelector('[data-ej-checkout-label]') || b.querySelector('.btn-text span') || b.querySelector('.btn-text');
      if (lbl && _ejCheckoutOrigLabel) lbl.textContent = _ejCheckoutOrigLabel;
      var secureIcon = b.querySelector('.secure-icon');
      if (secureIcon) secureIcon.style.display = '';
      var arrowIcon = b.querySelector('.arrow-icon');
      if (arrowIcon) arrowIcon.style.display = '';
      b.style.opacity = '';
      b.style.pointerEvents = '';
      b.disabled = false;
      b.classList.remove('disabled');
    });
  }

  /**
   * Gate: if an add-to-cart POST is still in flight, queue the checkout
   * and auto-fire it once the server confirms. Returns true if queued.
   */
  function ejGateCheckoutIfAdding(proceedFn) {
    if (!window._ejAddInFlight) return false;
    window._ejPendingCheckout = true;
    window._ejPendingCheckoutFn = proceedFn || null;
    ejSetCheckoutProcessing();
    return true;
  }

  /* Intercept native form checkout submit */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.id !== 'CartDrawer-Form') return;
    if (!e.submitter || e.submitter.getAttribute('name') !== 'checkout') return;
    if (form.getAttribute('data-require-terms') === 'true') {
      var cb = document.getElementById('term_checkbox');
      if (cb && !cb.checked) {
        e.preventDefault();
        alert('Please accept the terms to continue.');
        return;
      }
    }
    if (ejGateCheckoutIfAdding(function () { form.submit(); })) {
      e.preventDefault();
      return;
    }
  });

  /* Intercept GoKwik checkout button click */
  var _origOnCheckoutClick = window.onCheckoutClick;

  window.onCheckoutClick = function (btn) {
    if (ejGateCheckoutIfAdding(function () {
      if (typeof _origOnCheckoutClick === 'function') _origOnCheckoutClick(btn);
    })) return;
    if (typeof _origOnCheckoutClick === 'function') {
      _origOnCheckoutClick(btn);
    }
  };

  /* Re-intercept after GoKwik script loads (it may overwrite onCheckoutClick) */
  var _gkCheckInterval = setInterval(function () {
    if (window.onCheckoutClick && !window.onCheckoutClick._ejIntercepted) {
      var gkOriginal = window.onCheckoutClick;
      window.onCheckoutClick = function (btn) {
        if (ejGateCheckoutIfAdding(function () { gkOriginal(btn); })) return;
        gkOriginal(btn);
      };
      window.onCheckoutClick._ejIntercepted = true;
      clearInterval(_gkCheckInterval);
    }
  }, 500);
  setTimeout(function () { clearInterval(_gkCheckInterval); }, 15000);

  /** Coalesce rapid cart-drawer-updated bursts (quantity changes, section refresh) into one rAF. */
  var cartDrawerUpdatedRaf = null;
  function onCartDrawerUpdated() {
    if (cartDrawerUpdatedRaf) cancelAnimationFrame(cartDrawerUpdatedRaf);
    cartDrawerUpdatedRaf = requestAnimationFrame(function () {
      cartDrawerUpdatedRaf = null;
      var cd = document.getElementById('CartDrawer');
      if (
        cd &&
        (cd.querySelector('[data-b1g1-card]') ||
          cd.querySelector('.offer-card[data-offer="dynamic"]') ||
          cd.querySelector('.offer-tier-card[data-offer="tier-spend"]'))
      ) {
        runOfferCard(document.querySelector('cart-drawer-items') || document);
      }
      refreshCartDrawerRecommendedSwiperLayout();
      loadRecentlyViewedRecommended();
    });
  }

  /* ---- Recently Viewed → Cart Drawer Recommended ---- */
  var rvRecLoaded = false;

  /* Pre-fetch recently viewed products on page load so they're ready instantly when cart opens */
  var rvRecCachedProducts = null;
  var rvRecPrefetchPromise = null;
  
  function prefetchRecentlyViewedProducts() {
    if (rvRecPrefetchPromise) return rvRecPrefetchPromise;
    if (typeof Storage === 'undefined') return Promise.resolve(null);
    
    var raw;
    try { raw = localStorage.getItem('recentlyViewed'); } catch (e) { return Promise.resolve(null); }
    var list;
    try { list = raw ? JSON.parse(raw) : []; } catch (e) { list = []; }
    if (!Array.isArray(list) || list.length === 0) return Promise.resolve(null);
    
    var apiRoot = '';
    var rootEl = document.querySelector('[data-rv-api-root]');
    if (rootEl) apiRoot = (rootEl.getAttribute('data-rv-api-root') || '').replace(/\/$/, '');
    
    var handles = list
      .map(function (item) {
        if (typeof item === 'string') return item.trim() || null;
        if (item && typeof item.handle === 'string') return item.handle.trim() || null;
        return null;
      })
      .filter(function (h) { return h && h !== 'null' && h !== 'undefined'; })
      .slice(0, 4);

    if (!handles.length) return Promise.resolve(null);

    function fetchSequential(remaining, results) {
      if (!remaining.length) return Promise.resolve(results);
      var handle = remaining[0];
      var url = apiRoot + '/products/' + encodeURIComponent(handle) + '.js';
      return fetch(url).then(function (r) {
        return r.ok ? r.json() : null;
      }).catch(function () { return null; })
      .then(function (product) {
        results.push(product);
        if (remaining.length <= 1) return results;
        return new Promise(function (resolve) {
          setTimeout(function () { resolve(fetchSequential(remaining.slice(1), results)); }, 150);
        });
      });
    }

    rvRecPrefetchPromise = fetchSequential(handles, []).then(function (products) {
      rvRecCachedProducts = products;
      return products;
    });
    
    return rvRecPrefetchPromise;
  }
  
  /* Defer prefetch so it doesn't compete with page-critical requests */
  if (typeof requestIdleCallback === 'function') {
    requestIdleCallback(function () { prefetchRecentlyViewedProducts(); });
  } else {
    setTimeout(function () { prefetchRecentlyViewedProducts(); }, 2000);
  }

  function rvRecFormatMoney(cents, fmt) {
    var abs = Math.abs(Number(cents));
    if (!fmt) return 'Rs. ' + (abs / 100).toFixed(abs % 100 === 0 ? 0 : 2);
    var amount = (abs / 100).toFixed(2);
    var parts = amount.split('.');
    var noDecimals = parts[0];
    var withComma = noDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var wholeRupees = abs % 100 === 0;
    var display = wholeRupees ? noDecimals : amount;
    var commaSep = wholeRupees ? withComma : withComma + '.' + parts[1];
    return String(fmt)
      .replace(/\{\{\s*amount\s*\}\}/g, display)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, commaSep);
  }

  function rvRecBuildCard(p, cartAddUrl, moneyFormat) {
    if (!p || !p.variants || !p.variants.length) return null;
    var variant = null;
    for (var i = 0; i < p.variants.length; i++) {
      if (p.variants[i].available) { variant = p.variants[i]; break; }
    }
    if (!variant) variant = p.variants[0];
    if (!variant || !variant.available) return null;

    var imgSrc = p.featured_image || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
    if (imgSrc && imgSrc.indexOf('//') === 0) imgSrc = 'https:' + imgSrc;
    var url = p.url || '/products/' + (p.handle || '');
    if (url.indexOf('http') === 0) {
      try { var abs = new URL(url, window.location.href); if (abs.origin === window.location.origin) url = abs.pathname; } catch (e) {}
    }
    var title = p.title || '';
    var price = Number(variant.price);

    var slide = document.createElement('div');
    slide.className = 'swiper-slide cart-drawer-rec-slide';

    var article = document.createElement('article');
    article.className = 'cart-drawer-rec-card';

    var mediaLink = document.createElement('a');
    mediaLink.href = url;
    mediaLink.className = 'cart-drawer-rec-card__media';
    mediaLink.tabIndex = -1;
    mediaLink.setAttribute('aria-hidden', 'true');
    if (imgSrc) {
      var img = document.createElement('img');
      img.className = 'cart-drawer-rec-card__img';
      img.src = imgSrc;
      img.alt = title;
      img.loading = 'lazy';
      img.width = 90;
      img.height = 90;
      mediaLink.appendChild(img);
    } else {
      var ph = document.createElement('span');
      ph.className = 'cart-drawer-rec-card__img cart-drawer-rec-card__img--placeholder';
      mediaLink.appendChild(ph);
    }
    article.appendChild(mediaLink);

    var body = document.createElement('div');
    body.className = 'cart-drawer-rec-card__body';
    var titleLink = document.createElement('a');
    titleLink.href = url;
    titleLink.className = 'cart-drawer-rec-card__title';
    titleLink.textContent = title;
    body.appendChild(titleLink);

    var row = document.createElement('div');
    row.className = 'cart-drawer-rec-card__row';
    var priceSpan = document.createElement('span');
    priceSpan.className = 'cart-drawer-rec-card__price';
    priceSpan.textContent = rvRecFormatMoney(price, moneyFormat);
    row.appendChild(priceSpan);

    var form = document.createElement('form');
    form.action = cartAddUrl || '/cart/add';
    form.method = 'post';
    form.className = 'shop-card__form cart-drawer-rec-card__form';
    var idInput = document.createElement('input');
    idInput.type = 'hidden'; idInput.name = 'id'; idInput.value = String(variant.id);
    var qtyInput = document.createElement('input');
    qtyInput.type = 'hidden'; qtyInput.name = 'quantity'; qtyInput.value = '1';
    var btn = document.createElement('button');
    btn.type = 'submit'; btn.className = 'cart-drawer-rec-card__add';
    btn.name = 'add'; btn.setAttribute('aria-label', 'Add ' + title);
    btn.textContent = '+ Add';
    form.appendChild(idInput);
    form.appendChild(qtyInput);
    form.appendChild(btn);
    row.appendChild(form);

    body.appendChild(row);
    article.appendChild(body);
    slide.appendChild(article);
    return slide;
  }

  function renderRecommendedCards(container, wrapper, products) {
    var maxProducts = parseInt(container.getAttribute('data-rv-max') || '12', 10) || 12;
    var cartAddUrl = container.getAttribute('data-rv-cart-add-url') || '/cart/add';
    var moneyFormat = container.getAttribute('data-rv-money-format') || '';
    
    wrapper.innerHTML = '';
    var count = 0;
    for (var i = 0; i < products.length; i++) {
      if (count >= maxProducts) break;
      var p = products[i];
      if (!p) continue;
      var card = rvRecBuildCard(p, cartAddUrl, moneyFormat);
      if (card) {
        wrapper.appendChild(card);
        count++;
      }
    }
    if (count > 0) {
      container.hidden = false;
      rvRecLoaded = true;
      var swiperEl = container.querySelector('.cart-drawer__recommended-swiper');
      if (swiperEl) {
        swiperEl.removeAttribute('data-swiper-inited');
        if (swiperEl.swiper) {
          try { swiperEl.swiper.destroy(true, true); } catch (e) {}
        }
      }
      requestAnimationFrame(function () {
        refreshCartDrawerRecommendedSwiperLayout();
      });
    }
  }

  function loadRecentlyViewedRecommended() {
    var container = document.querySelector('#CartDrawer [data-cart-drawer-recommended]');
    if (!container) return;
    var wrapper = container.querySelector('[data-rv-rec-wrapper]');
    if (!wrapper) return;
    if (wrapper.children.length > 0) return;
    if (typeof Storage === 'undefined') return;

    /* Use pre-fetched cache if available — renders instantly, no network wait */
    if (rvRecCachedProducts) {
      renderRecommendedCards(container, wrapper, rvRecCachedProducts);
      return;
    }

    /* Cache is still loading — wait for it instead of firing duplicate fetches */
    if (rvRecPrefetchPromise) {
      rvRecPrefetchPromise.then(function (products) {
        if (!products) return;
        var c = document.querySelector('#CartDrawer [data-cart-drawer-recommended]');
        if (!c) return;
        var w = c.querySelector('[data-rv-rec-wrapper]');
        if (!w || w.children.length > 0) return;
        renderRecommendedCards(c, w, products);
      });
      return;
    }

    /* Fallback: no prefetch happened, fetch now */
    var maxProducts = parseInt(container.getAttribute('data-rv-max') || '12', 10) || 12;
    var apiRoot = (container.getAttribute('data-rv-api-root') || '').replace(/\/$/, '');

    var raw;
    try { raw = localStorage.getItem('recentlyViewed'); } catch (e) { return; }
    var list;
    try { list = raw ? JSON.parse(raw) : []; } catch (e) { list = []; }
    if (!Array.isArray(list) || list.length === 0) return;

    var handles = list
      .map(function (item) {
        if (typeof item === 'string') return item.trim() || null;
        if (item && typeof item.handle === 'string') return item.handle.trim() || null;
        return null;
      })
      .filter(function (h) { return h && h !== 'null' && h !== 'undefined'; })
      .slice(0, Math.min(maxProducts, 4));

    if (!handles.length) return;

    function fetchSeq(remaining, results) {
      if (!remaining.length) return Promise.resolve(results);
      var url = apiRoot + '/products/' + encodeURIComponent(remaining[0]) + '.js';
      return fetch(url).then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; })
        .then(function (p) {
          results.push(p);
          if (remaining.length <= 1) return results;
          return new Promise(function (resolve) {
            setTimeout(function () { resolve(fetchSeq(remaining.slice(1), results)); }, 150);
          });
        });
    }
    fetchSeq(handles, []).then(function (products) {
      rvRecCachedProducts = products;
      renderRecommendedCards(container, wrapper, products);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    runOfferCard(document);
    loadRecentlyViewedRecommended();
    requestAnimationFrame(refreshCartDrawerRecommendedSwiperLayout);
    window.addEventListener(
      'resize',
      debounce(function () {
        syncLunaTierTrackExtents(document.getElementById('CartDrawer') || document);
      }, 100),
      { passive: true }
    );
    var cartDrawerEl = document.querySelector('cart-drawer');
    if (cartDrawerEl) {
      cartDrawerEl.addEventListener(
        'transitionend',
        debounce(function () {
          if (!cartDrawerEl.classList.contains('active')) return;
          syncLunaTierTrackExtents(document.getElementById('CartDrawer') || document);
        }, 50)
      );
    }
    document.addEventListener('cart-drawer-updated', onCartDrawerUpdated);

    document.body.addEventListener('click', function (e) {
      var t = e.target.closest('[data-dz-modal]');
      if (!t) return;
      var sel = t.getAttribute('data-dz-modal');
      var modal = sel && document.querySelector(sel);
      if (modal) {
        e.preventDefault();
        modal.classList.add('is-open');
      }
    });
    document.body.addEventListener('click', function (e) {
      if (e.target.closest('.modal-close')) {
        e.preventDefault();
        var m = e.target.closest('.modal');
        if (m) m.classList.remove('is-open');
      }
    });
  });
})();
